import {
  scalingworks_default,
  useInternalTranslate
} from "./chunk-3NGQI43U.mjs";
import {
  useI18nFeature
} from "./chunk-PJUONHKW.mjs";

// src/components/search-input.tsx
import {
  Spinner,
  TextInput,
  TextField
} from "@scalingworks/react-admin-ui";
import { clsx } from "clsx";
import * as React from "react";
import { HiSearch } from "react-icons/hi";
var SearchInput = ({
  isLoading,
  fullWidthWhenContentNarrow,
  placeholder,
  containerType = "flexible",
  ...props
}) => {
  const t = useInternalTranslate();
  const renderTextInput = () => /* @__PURE__ */ React.createElement(
    TextInput,
    {
      placeholder: placeholder || t("pages.list.search", { fallback: scalingworks_default.pages.list.search }),
      type: "search",
      size: "sm",
      prefix: /* @__PURE__ */ React.createElement(HiSearch, { className: "text-gray-500 group-focus-within:text-primary-600" }),
      suffix: isLoading ? /* @__PURE__ */ React.createElement(Spinner, null) : null,
      ...props
    }
  );
  if (containerType === "fixed") {
    return /* @__PURE__ */ React.createElement("div", { className: "flex justify-start w-full" }, /* @__PURE__ */ React.createElement(
      TextField,
      {
        layout: "vertical",
        label: t("pages.list.search", {
          fallback: scalingworks_default.pages.list.search
        }),
        placeholder: placeholder || t("pages.list.search", { fallback: scalingworks_default.pages.list.search }),
        type: "search",
        size: "sm",
        prefix: /* @__PURE__ */ React.createElement(HiSearch, { className: "text-gray-500 group-focus-within:text-primary-600" }),
        suffix: isLoading ? /* @__PURE__ */ React.createElement(Spinner, null) : null,
        fieldGroupProps: {
          className: "w-full"
        },
        ...props
      }
    ));
  }
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: clsx(
        "flex justify-end",
        fullWidthWhenContentNarrow ? "w-full @lg/content:w-60" : "w-60"
      )
    },
    /* @__PURE__ */ React.createElement(
      "div",
      {
        className: clsx(
          "transition-all ease-in-out group",
          fullWidthWhenContentNarrow ? [
            "w-full",
            props.value ? "@lg/content:w-60" : "@lg/content:w-28 @lg/content:focus-within:w-60"
          ] : props.value ? "w-60" : "w-28 focus-within:w-60"
        )
      },
      renderTextInput()
    )
  );
};

// src/index.ts
import { sentenceCase as sentenceCase2 } from "change-case";

// src/components/content.tsx
import { Skeleton, isString } from "@scalingworks/react-admin-ui";
import { clsx as clsx2 } from "clsx";
import * as React2 from "react";
var Content = ({
  title,
  extra,
  children,
  isLoading,
  className,
  showTitle = true,
  ...divProps
}) => /* @__PURE__ */ React2.createElement(
  "div",
  {
    className: clsx2("max-w-screen-2xl mx-auto px-4 pb-6 @container/content", className),
    ...divProps
  },
  showTitle && /* @__PURE__ */ React2.createElement("div", { className: "flex justify-between items-center gap-5 flex-wrap py-3" }, isString(title) ? /* @__PURE__ */ React2.createElement("h1", { className: "text-2xl font-bold" }, title) : title ? /* @__PURE__ */ React2.createElement("div", null, title) : isLoading ? /* @__PURE__ */ React2.createElement(Skeleton, { className: "animate-pulse", heightClass: "h-8", width: "medium" }) : null, /* @__PURE__ */ React2.createElement("div", { className: "flex-1 flex justify-end items-center gap-2" }, extra)),
  children
);

// src/components/link-to-details.tsx
import { useNavigation, useRouterContext } from "@refinedev/core";
import { callAll } from "@scalingworks/react-admin-ui";
import * as React4 from "react";

// src/hooks/use-prefetch.ts
import { createNamedContext } from "@scalingworks/react-admin-ui";
import * as React3 from "react";
var PrefetchContext = createNamedContext(function noop() {
}, "Prefetch");
var PrefetchContextProvider = PrefetchContext.Provider;
var usePrefetch = () => React3.useContext(PrefetchContext);

// src/components/link-to-details.tsx
var LinkToDetails = React4.forwardRef(
  function LinkToDetails2({ resourceId, resourceName, ...props }, forwardedRef) {
    const { Link } = useRouterContext();
    const { showUrl } = useNavigation();
    const prefetch = usePrefetch();
    return /* @__PURE__ */ React4.createElement(
      Link,
      {
        ...props,
        to: showUrl(resourceName, resourceId),
        onMouseEnter: callAll(props.onMouseEnter, () => prefetch(resourceName, resourceId)),
        onFocus: callAll(props.onFocus, () => prefetch(resourceName, resourceId)),
        ref: forwardedRef
      }
    );
  }
);

// src/create-refine-admin-app.tsx
import DataLoader from "dataloader";
import { GraphQLClient } from "graphql-request";
import * as React14 from "react";

// src/components/create-layout.tsx
import {
  useBreadcrumb,
  useGetIdentity as useGetIdentity2,
  useLogout,
  useMenu,
  useRouterContext as useRouterContext2,
  useTranslate
} from "@refinedev/core";
import {
  Avatar,
  Dialog,
  Menu,
  Sidebar,
  isFunction,
  usePersistedState
} from "@scalingworks/react-admin-ui";
import { clsx as clsx3 } from "clsx";
import * as React7 from "react";
import { HiChevronRight, HiOutlineLogout, HiOutlineMenu, HiOutlineMenuAlt2 } from "react-icons/hi";

// src/lib/prefetch.tsx
import { useShow } from "@refinedev/core";
import { isSimilarArray } from "@scalingworks/react-admin-ui";
import * as React5 from "react";
var createPrefetchMap = () => {
  let isSealed = false;
  const prefetchMap = /* @__PURE__ */ new Map();
  return {
    addFields(resourceName, fields) {
      if (isSealed) {
        throw new Error(`Trying to addFields for prefetch after sealed.`);
      }
      const currentItem = prefetchMap.get(resourceName);
      if (currentItem) {
        const hasAdded = currentItem.some((currentFields) => isSimilarArray(currentFields, fields));
        if (!hasAdded) {
          currentItem.push(fields);
        }
      } else {
        prefetchMap.set(resourceName, [fields]);
      }
    },
    seal() {
      isSealed = true;
    },
    getAll() {
      return Array.from(prefetchMap, ([resourceName, fieldsSet]) => ({
        resourceName,
        fieldsSet
      }));
    }
  };
};
var createPrefetchProvider = (map) => {
  const resourceFields = map.getAll();
  return function PrefetchProvider(props) {
    const useStates = resourceFields.map(() => React5.useState(""));
    resourceFields.forEach((field, resourceIndex) => {
      const idToPrefetch = useStates[resourceIndex][0];
      return field.fieldsSet.forEach(
        (fields) => useShow({
          resource: field.resourceName,
          id: idToPrefetch,
          metaData: {
            fields
          },
          queryOptions: {
            enabled: !!idToPrefetch
          }
        })
      );
    });
    const setIdToPrefetch = React5.useCallback(
      (resourceName, id) => {
        const resourceIndex = resourceFields.findIndex(
          (field) => field.resourceName === resourceName
        );
        if (resourceIndex > -1) {
          useStates[resourceIndex][1](id);
        }
      },
      []
    );
    return /* @__PURE__ */ React5.createElement(PrefetchContextProvider, { value: setIdToPrefetch }, props.children);
  };
};

// src/modules/access-control/lib/is-action-allowed.ts
import { singular } from "pluralize";
function isActionAllowed(data, permissionGrants) {
  return Array.isArray(permissionGrants) && permissionGrants.length > 0 && permissionGrants.some((permission) => {
    const hasPermissionForResource = permission.resource === singular(data.resource) && (permission.action === data.action || permission.action === "*");
    if (hasPermissionForResource) {
      return true;
    }
    const hasPermissionForAllResources = permission.resource === "*" && (permission.action === data.action || permission.action === "*");
    return hasPermissionForAllResources;
  });
}

// src/modules/access-control/create-access-control-provider.ts
var createAccessControlProvider = (authProvider, options) => {
  let prevRequest = null;
  return {
    can: async (canParams) => {
      if (canParams.resource) {
        try {
          if (!prevRequest) {
            prevRequest = authProvider.getIdentity();
            prevRequest.then(() => {
              setTimeout(() => {
                prevRequest = null;
              }, options.refreshIntervalMs);
            });
          }
          const identity = await prevRequest;
          if (identity.me.role) {
            return {
              can: isActionAllowed(
                {
                  resource: canParams.resource,
                  action: mapAction(canParams.action)
                },
                identity.me.role.permissionGrants
              )
            };
          }
        } catch (err) {
          console.error("Error in accessControlProvider", err);
          prevRequest = null;
        }
      }
      return {
        can: false
      };
    }
  };
};
function mapAction(refineAction) {
  switch (refineAction) {
    case "list":
    case "show":
      return "read";
    case "create":
    case "edit":
      return "write";
    case "delete":
      return "delete";
    default:
      throw new Error(`Unhandled refine action: ${refineAction}`);
  }
}

// src/modules/access-control/hooks/use-filter-by-access.ts
import { useGetIdentity } from "@refinedev/core";
import * as React6 from "react";
function useFilterByAccess(originalItem, accessConfig) {
  if (!accessConfig)
    return originalItem;
  const { data } = useGetIdentity();
  return React6.useMemo(() => {
    if (!data || !data.me?.channels) {
      return [];
    }
    const finalMenu = [];
    const { channelCode = "__default_channel__", resourceControl } = accessConfig;
    const channel = data.me.channels.find((channel2) => channel2.code === channelCode);
    if (!channel) {
      console.warn(`Failed to get channel ${channelCode}`);
      return [];
    }
    const permissions = channel.permissions;
    for (const menu of originalItem) {
      const name = menu?.name;
      const requirePermissions = resourceControl[name]?.list;
      const granted = requirePermissions?.every((perm) => permissions.includes(perm));
      if (granted) {
        const filteredChildren = [];
        for (const subMenu of menu.children || []) {
          const childName = subMenu?.name;
          const requirePermissions2 = resourceControl[childName]?.list;
          const childGranted = requirePermissions2?.every((perm) => permissions.includes(perm));
          if (childGranted) {
            filteredChildren.push(subMenu);
          }
        }
        if (!menu.children.length) {
          finalMenu.push(menu);
        } else {
          if (filteredChildren.length > 0) {
            finalMenu.push({ ...menu, children: filteredChildren });
          }
        }
      }
    }
    return finalMenu;
  }, [data]);
}

// src/components/create-layout.tsx
var createLayout = (options) => {
  const PrefetchProvider = createPrefetchProvider(options.prefetchMap);
  return function Layout(props) {
    const { breadcrumbs } = useBreadcrumb();
    const translate = useTranslate();
    const t = useInternalTranslate();
    const getIdentity = useGetIdentity2();
    const logout = useLogout();
    const [sidebarCollapsed, setSidebarCollapsed] = usePersistedState(false, "sidebarCollapsed");
    const [isMobileSidebarOpen, setIsMobileSidebarOpen] = React7.useState(false);
    const user = React7.useMemo(
      () => getIdentity.data && {
        name: getIdentity.data.me.identifier
        // role: getIdentity.data.me.role?.name,
      },
      [getIdentity.data]
    );
    const { Link, useHistory } = useRouterContext2();
    const history = useHistory();
    const { menuItems: _menuItems, selectedKey } = useMenu();
    const menuItems = useFilterByAccess(
      _menuItems,
      options.accessConfig
    );
    const allMenus = React7.useMemo(() => {
      if (options.DashboardPage) {
        const { title = "Dashboard", icon } = options.DashboardPage;
        const dashboardItem = {
          name: "dashboard",
          label: isFunction(title) ? title({ t }) : title,
          route: "/",
          children: [],
          icon
        };
        return [dashboardItem].concat(menuItems);
      }
      return menuItems;
    }, [menuItems]);
    React7.useEffect(() => {
      setIsMobileSidebarOpen(false);
    }, [selectedKey]);
    return /* @__PURE__ */ React7.createElement(PrefetchProvider, null, /* @__PURE__ */ React7.createElement("div", { className: "flex h-screen" }, /* @__PURE__ */ React7.createElement("div", { className: "hidden sm:block" }, /* @__PURE__ */ React7.createElement(
      Sidebar,
      {
        header: sidebarCollapsed ? options.sidebarCollapsedHeader : options.sidebarHeader,
        width: sidebarCollapsed ? "collapsed" : "expanded",
        variant: options.sidebarVariant,
        items: allMenus,
        selectedKey,
        renderLink: (linkProps) => /* @__PURE__ */ React7.createElement(Link, { ...linkProps }),
        onNavigate: (to) => history.push(to),
        className: "h-full"
      }
    )), /* @__PURE__ */ React7.createElement("div", { className: "flex-1 flex flex-col min-w-0" }, /* @__PURE__ */ React7.createElement("div", { className: "flex justify-between h-[60px] p-3 bg-white border-b border-gray-200" }, /* @__PURE__ */ React7.createElement("div", { className: "flex items-center gap-1 sm:gap-3" }, /* @__PURE__ */ React7.createElement(
      "button",
      {
        onClick: () => setSidebarCollapsed(!sidebarCollapsed),
        type: "button",
        className: "hidden sm:block p-1"
      },
      sidebarCollapsed ? /* @__PURE__ */ React7.createElement(HiOutlineMenuAlt2, null) : /* @__PURE__ */ React7.createElement(HiOutlineMenu, null)
    ), /* @__PURE__ */ React7.createElement(Dialog.Root, { open: isMobileSidebarOpen, onOpenChange: setIsMobileSidebarOpen }, /* @__PURE__ */ React7.createElement(Dialog.Trigger, { className: "flex sm:hidden items-center justify-center w-8 h-8 rounded-full" }, /* @__PURE__ */ React7.createElement(HiOutlineMenu, null)), /* @__PURE__ */ React7.createElement(Dialog.Portal, null, /* @__PURE__ */ React7.createElement(Dialog.Overlay, null), /* @__PURE__ */ React7.createElement(Dialog.LeftContent, { className: "min-w-[50%]" }, /* @__PURE__ */ React7.createElement(
      Sidebar,
      {
        header: options.sidebarHeader,
        width: "full",
        variant: options.sidebarVariant,
        items: menuItems,
        selectedKey,
        renderLink: (linkProps) => /* @__PURE__ */ React7.createElement(Link, { ...linkProps }),
        onNavigate: (to) => history.push(to),
        className: "h-full"
      }
    )))), breadcrumbs.map((item, index) => /* @__PURE__ */ React7.createElement(
      BreadcrumbItem,
      {
        item,
        isLastItem: index === breadcrumbs.length - 1,
        key: index
      }
    ))), /* @__PURE__ */ React7.createElement("div", { className: "flex items-center gap-1" }, options?.quickActions, user && /* @__PURE__ */ React7.createElement(Menu.Root, null, /* @__PURE__ */ React7.createElement(Menu.Trigger, { className: "flex items-center gap-2 px-2 rounded select-none focus:outline-none focus-visible:ring focus-visible:ring-primary-200" }, /* @__PURE__ */ React7.createElement(Avatar, { text: user.name }), /* @__PURE__ */ React7.createElement("span", { className: "hidden md:block text-left text-gray-500" }, /* @__PURE__ */ React7.createElement("span", { className: "block text-sm font-bold" }, user.name))), /* @__PURE__ */ React7.createElement(Menu.Portal, null, /* @__PURE__ */ React7.createElement(Menu.Content, { align: "end", style: { minWidth: 200 } }, options.userMenus && /* @__PURE__ */ React7.createElement(React7.Fragment, null, options.userMenus.map((menuItem, index) => /* @__PURE__ */ React7.createElement(
      UserMenuItem,
      {
        onSelect: menuItem.to ? () => history.push(menuItem.to) : void 0,
        icon: menuItem.icon,
        key: index
      },
      menuItem.label
    )), /* @__PURE__ */ React7.createElement(Menu.Separator, { className: "h-px bg-gray-200" })), options.i18n && /* @__PURE__ */ React7.createElement(React7.Suspense, { fallback: null }, /* @__PURE__ */ React7.createElement(LanguageSwitcher, { settings: options.i18n })), /* @__PURE__ */ React7.createElement(UserMenuItem, { onSelect: () => logout.mutate(), icon: /* @__PURE__ */ React7.createElement(HiOutlineLogout, null) }, translate("buttons.logout", "Logout"))))))), /* @__PURE__ */ React7.createElement("main", { className: "flex-1 bg-white overflow-y-auto relative" }, props.children))));
  };
};
var UserMenuItem = ({
  children,
  icon,
  className,
  ...props
}) => /* @__PURE__ */ React7.createElement(Menu.Item, { ...props, className: clsx3("flex gap-2", className) }, React7.isValidElement(icon) ? React7.cloneElement(icon, {
  className: clsx3("w-5 h-5 text-gray-500", icon.props.className),
  width: 20,
  height: 20
}) : icon, children);
var BreadcrumbItem = ({ item, isLastItem }) => {
  const { Link } = useRouterContext2();
  return /* @__PURE__ */ React7.createElement(React7.Fragment, null, item.href && !isLastItem ? /* @__PURE__ */ React7.createElement(Link, { to: item.href, className: "text-sm hover:underline" }, item.label) : /* @__PURE__ */ React7.createElement("span", { className: "text-sm" }, item.label), !isLastItem && /* @__PURE__ */ React7.createElement(HiChevronRight, { width: 20, height: 20, "aria-hidden": true }));
};
var LanguageSwitcher = React7.lazy(
  () => import("./language-switcher-3YGRLNY5.mjs").then((m) => ({
    default: m.LanguageSwitcherMenu
  }))
);

// src/components/create-login-page.tsx
import { useLogin, useTranslate as useTranslate2 } from "@refinedev/core";
import { useForm } from "@refinedev/react-hook-form";
import { Button, PasswordField, TextField as TextField2 } from "@scalingworks/react-admin-ui";
import * as React8 from "react";
import { Helmet } from "react-helmet";
var LanguageSwitcherRow = React8.lazy(
  () => import("./language-switcher-3YGRLNY5.mjs").then((m) => ({
    default: m.LanguageSwitcherRow
  }))
);
var createLoginPage = ({
  header,
  i18n,
  defaultPassword = "",
  defaultUsername = ""
}) => function LoginPage() {
  const { register, handleSubmit } = useForm({
    defaultValues: {
      username: defaultPassword,
      password: defaultUsername,
      remember: true
    }
  });
  const loginMutation = useLogin();
  const translate = useTranslate2();
  return /* @__PURE__ */ React8.createElement("div", { className: "px-3 py-12" }, /* @__PURE__ */ React8.createElement(Helmet, null, /* @__PURE__ */ React8.createElement("title", null, translate("pages.login.title", "Sign in to your account"))), /* @__PURE__ */ React8.createElement("main", { className: "max-w-lg mx-auto p-12 bg-white shadow" }, header, /* @__PURE__ */ React8.createElement(
    "form",
    {
      className: "flex flex-col gap-3",
      onSubmit: handleSubmit((data) => loginMutation.mutate(data))
    },
    /* @__PURE__ */ React8.createElement(
      TextField2,
      {
        label: translate("pages.login.fields.email", "Email"),
        type: "email",
        autoComplete: "username",
        ...register("username", { required: true }),
        layout: "vertical",
        disabled: loginMutation.isLoading
      }
    ),
    /* @__PURE__ */ React8.createElement(
      PasswordField,
      {
        label: translate("pages.login.fields.password", "Password"),
        disabled: loginMutation.isLoading,
        layout: "vertical",
        autoComplete: "current-password",
        ...register("password", { required: true })
      }
    ),
    /* @__PURE__ */ React8.createElement(
      Button,
      {
        type: "submit",
        loading: loginMutation.isLoading,
        variant: "solid",
        className: "w-full"
      },
      translate("pages.login.buttons.submit", "Sign in")
    )
  )), i18n && /* @__PURE__ */ React8.createElement(LanguageSwitcherRow, { settings: i18n }));
};

// src/components/create-provider.tsx
import { Spinner as Spinner2, Toast, Tooltip } from "@scalingworks/react-admin-ui";
import * as React10 from "react";

// src/hooks/use-graphql-client.ts
import * as React9 from "react";
var GraphQLClientContext = React9.createContext(void 0);
var useGraphQLClient = () => {
  const client = React9.useContext(GraphQLClientContext);
  if (!client) {
    throw new Error(`GraphQLClient not available`);
  }
  return client;
};

// src/components/create-provider.tsx
var createProvider = (options) => {
  const waitForPromise = options.waitForPromise;
  const PassThrough = (props) => /* @__PURE__ */ React10.createElement(React10.Fragment, null, props.children);
  const WaitForPromiseContainer = waitForPromise ? React10.lazy(() => waitForPromise.then(() => ({ default: PassThrough }))) : PassThrough;
  return function RefineAppProvider(props) {
    const [notifications, setNotifications] = React10.useState([]);
    React10.useEffect(() => {
      const onOpen = (data) => {
        setNotifications((prevNotifications) => {
          const result = [];
          let isUpdate = false;
          for (const notification of prevNotifications) {
            if (notification.key === data.key) {
              isUpdate = true;
              result.push(data);
            } else {
              result.push(notification);
            }
          }
          if (!isUpdate) {
            result.push(data);
          }
          return result;
        });
      };
      const onClose = (data) => {
        setNotifications(
          (prevNotifications) => prevNotifications.filter((n) => n.key !== data.key)
        );
      };
      options.eventBus.on("open", onOpen);
      options.eventBus.on("close", onClose);
      return () => {
        options.eventBus.off("open", onOpen);
        options.eventBus.off("close", onClose);
      };
    }, []);
    const content = /* @__PURE__ */ React10.createElement(Tooltip.Provider, null, /* @__PURE__ */ React10.createElement(Toast.Provider, null, /* @__PURE__ */ React10.createElement(GraphQLClientContext.Provider, { value: options.graphqlClient }, props.children, notifications.map((notification, index) => /* @__PURE__ */ React10.createElement(
      Toast.Notification,
      {
        variant: notificationVariant[notification.type],
        onOpenChange: (open) => {
          if (!open) {
            setNotifications(
              (prevNotification) => prevNotification.filter((n) => n !== notification)
            );
          }
        },
        key: notification.key || index
      },
      /* @__PURE__ */ React10.createElement(Toast.Title, null, notification.message),
      notification.description && /* @__PURE__ */ React10.createElement(Toast.Description, null, notification.description)
    )), /* @__PURE__ */ React10.createElement(Toast.Viewport, null))));
    return options.waitForPromise ? /* @__PURE__ */ React10.createElement(
      React10.Suspense,
      {
        fallback: /* @__PURE__ */ React10.createElement("div", { className: "h-screen w-screen flex items-center justify-center" }, /* @__PURE__ */ React10.createElement(Spinner2, null))
      },
      /* @__PURE__ */ React10.createElement(WaitForPromiseContainer, null, content)
    ) : content;
  };
};
var notificationVariant = {
  error: "danger",
  success: "success",
  progress: "info"
};

// src/components/header.tsx
import { useGetIdentity as useGetIdentity3 } from "@refinedev/core";
import * as React11 from "react";
var Header = () => {
  const { data } = useGetIdentity3();
  return /* @__PURE__ */ React11.createElement("header", { className: "flex justify-end items-center h-16 px-6 bg-white " }, /* @__PURE__ */ React11.createElement("div", null, data && /* @__PURE__ */ React11.createElement(React11.Fragment, null, /* @__PURE__ */ React11.createElement("div", { className: "text-ellipsis" }, data.me?.name))));
};

// src/components/refine-admin-app.tsx
import { Refine } from "@refinedev/core";
import * as React12 from "react";
var RefineAdminApp = (props) => {
  if (props.i18n) {
    return /* @__PURE__ */ React12.createElement(props.Provider, null, /* @__PURE__ */ React12.createElement(I18nFeatureProvider, { settings: props.i18n }, /* @__PURE__ */ React12.createElement(RefineAdminInnerApp, { refine: props.refine })));
  }
  return /* @__PURE__ */ React12.createElement(props.Provider, null, /* @__PURE__ */ React12.createElement(RefineAdminInnerApp, { refine: props.refine }));
};
var RefineAdminInnerApp = (props) => {
  const i18nProvider = useI18nFeature();
  return /* @__PURE__ */ React12.createElement(Refine, { ...props.refine, i18nProvider });
};
var I18nFeatureProvider = React12.lazy(
  () => import("./i18n-feature-provider-THGWEA77.mjs").then((m) => ({ default: m.I18nFeatureProvider }))
);

// src/create-auth-provider.ts
import { gql } from "graphql-request";
var createAuthProvider = ({
  authStorageKey,
  graphqlClient
}) => {
  const authProvider = {
    login: async ({ username, password }) => {
      try {
        const query2 = gql`
					mutation ($username: String!, $password: String!) {
						adminLogin(data: { username: $username, password: $password }) {
							accessToken
							expiresIn
							refreshToken
							refreshExpiresIn
						}
					}
				`;
        const variables = {
          username,
          password
        };
        const response = await graphqlClient.request(query2, variables);
        graphqlClient.setHeaders({
          authorization: `Bearer ${response.adminLogin.accessToken}`
        });
        localStorage.setItem(authStorageKey, JSON.stringify(response.adminLogin));
        return Promise.resolve({ success: true });
      } catch (error) {
        console.log("login ERROR", error);
        return Promise.resolve({ success: false, error });
      }
    },
    logout: () => {
      localStorage.removeItem(authStorageKey);
      setTimeout(() => window.location.reload(), 500);
      return Promise.resolve({ success: true, redirectTo: "/login" });
    },
    onError: (error) => {
      if (error?.message?.includes?.("Unauthorized")) {
        return Promise.reject("/login");
      }
      return Promise.resolve({});
    },
    check: () => {
      const token = localStorage.getItem(authStorageKey);
      if (token) {
        return Promise.resolve({ authenticated: true });
      }
      return Promise.reject({ redirectPath: "/login" });
    },
    getPermissions: () => Promise.resolve(),
    getIdentity: async () => {
      const token = localStorage.getItem(authStorageKey);
      if (!token) {
        return Promise.reject();
      }
      try {
        const query2 = gql`
					{
						me {
							... on AdminUser {
								name
								role {
									name
									permissionGrants {
										resource
										action
									}
								}
							}
						}
					}
				`;
        const identity = await graphqlClient.request(query2);
        return Promise.resolve(identity);
      } catch (e) {
        return Promise.reject();
      }
    }
  };
  return authProvider;
};

// src/create-data-provider.ts
import { camelCase, pascalCase } from "change-case";
import * as gql2 from "gql-query-builder";
import { plural, singular as singular2 } from "pluralize";
var generateSort = (sort) => {
  if (sort && sort.length > 0) {
    const sortQuery = sort.map((i) => {
      return {
        [i.field]: i.order
      };
    });
    return sortQuery;
  }
  return [];
};
var generateFilter = (filters) => {
  let search = "";
  if (filters && filters.length > 0) {
    const filterBy = [];
    filters.forEach((filter) => {
      if ("field" in filter) {
        const { field, operator, value } = filter;
        if (field === "search") {
          search = value;
          return;
        }
        const stringFilter = primaStringFilterMappings[`${operator}`];
        if (stringFilter) {
          const matchNestedFilter = /^\.(\w+)\.(is|isNot)\.(\w+)((\|\||&&)(\w+))?$/.exec(field);
          const makeFilterObject = (fieldName) => ({
            [fieldName]: {
              [stringFilter]: value,
              ...stringFilter === "contains" ? {
                mode: "insensitive" /* Insensitive */
              } : {}
            }
          });
          if (matchNestedFilter) {
            const [, entityName, relType, entityField, , logicalOperator, anotherEntityField] = matchNestedFilter;
            filterBy.push({
              [entityName]: {
                [relType]: logicalOperator ? logicalOperator === "||" ? {
                  OR: [makeFilterObject(entityField), makeFilterObject(anotherEntityField)]
                } : {
                  AND: [makeFilterObject(entityField), makeFilterObject(anotherEntityField)]
                } : makeFilterObject(entityField)
              }
            });
          } else {
            const matchLogicalFilter = /^(\w+)(\|\||&&)(\w+)$/.exec(field);
            if (matchLogicalFilter) {
              const [, field1, logicalOperator, field2] = matchLogicalFilter;
              filterBy.push(
                logicalOperator === "||" ? {
                  OR: [makeFilterObject(field1), makeFilterObject(field2)]
                } : {
                  AND: [makeFilterObject(field1), makeFilterObject(field2)]
                }
              );
            } else {
              filterBy.push(makeFilterObject(field));
            }
          }
        }
      } else {
        const mapFilter = (filterItem) => {
          if ("field" in filterItem) {
            const { operator, value, field } = filterItem;
            const stringFilter = primaStringFilterMappings[`${operator}`];
            if (stringFilter) {
              return {
                [field]: {
                  [stringFilter]: value,
                  ...stringFilter === "contains" ? {
                    mode: "insensitive" /* Insensitive */
                  } : {}
                }
              };
            }
          } else {
            const { operator, value } = filterItem;
            return {
              [operator === "or" ? "OR" : "AND"]: value.map((item) => mapFilter(item))
            };
          }
        };
        filterBy.push(mapFilter(filter));
      }
    });
    return { filterBy, search };
  }
  return { filterBy: [], search };
};
var prismaInputType = {
  paginate: (name) => pascalCase(`${name}WhereUniqueInput`),
  findUnique: (name) => pascalCase(`${name}WhereUniqueInput`),
  findFirst: (name) => pascalCase(`${name}WhereInput`),
  findMany: (name) => pascalCase(`${name}WhereInput`),
  create: (name) => pascalCase(`${name}CreateInput`),
  createMany: (name) => pascalCase(`${name}CreateManyInput`),
  update: (name) => pascalCase(`${name}UpdateInput`),
  updateMany: (name) => pascalCase(`${name}UpdateManyInput`)
};
var primaStringFilterMappings = {
  eq: "equals",
  lt: "lt",
  gt: "gt",
  lte: "lte",
  gte: "gte",
  in: "in",
  nin: "notIn",
  contains: "contains",
  startswith: "startsWith",
  startswiths: "startsWith",
  endswith: "endsWith",
  endswiths: "endsWith",
  nstartswith: false,
  nstartswiths: false,
  nendswith: false,
  nendswiths: false,
  ne: false,
  ncontains: false,
  containss: false,
  ncontainss: false,
  null: false,
  nnull: false,
  between: false,
  nbetween: false
};
var createDataProvider = (client, resourceDataProvider, dataLoader) => {
  return {
    getList: async (info) => {
      const dataProvider = resourceDataProvider.get(info.resource);
      const customFetcher = dataProvider?.getList;
      if (customFetcher) {
        return customFetcher({
          ...info,
          client,
          dataLoader
        });
      }
      const { resource, pagination, sort, filters, metaData } = info;
      const current = pagination?.current || 1;
      const pageSize = pagination?.pageSize || 10;
      const orderBy = generateSort(sort);
      const { filterBy, search } = generateFilter(filters);
      const operation = metaData?.operation ?? camelCase(plural(resource));
      const singularResource = singular2(resource);
      try {
        const { query: query2, variables } = gql2.query({
          operation,
          variables: {
            ...orderBy.length > 0 && {
              page: current,
              perPage: pageSize,
              orderBy: {
                value: orderBy,
                type: `[${pascalCase(singularResource)}OrderByWithRelationInput!]`
              }
            },
            ...filterBy.length > 0 && {
              where: {
                value: {
                  AND: filterBy
                },
                type: prismaInputType.findMany(singularResource)
              }
            },
            ...search ? {
              search
            } : {}
          },
          fields: [
            { items: metaData?.fields },
            { metadata: ["currentPage", "totalPages", "totalCount", "perPage"] }
          ]
        });
        const { data } = await dataLoader.load({
          document: query2,
          variables
        });
        return {
          data: data[operation].items,
          total: data[operation].metadata?.totalCount,
          metadata: data[operation].metadata
        };
      } catch (err) {
        console.error(err);
        console.error(err);
        throw err;
      }
    },
    getMany: async (info) => {
      const dataProvider = resourceDataProvider.get(info.resource);
      const customFetcher = dataProvider?.getMany;
      if (customFetcher) {
        return customFetcher({
          ...info,
          client,
          dataLoader
        });
      }
      const { resource, ids, metaData } = info;
      const singularResource = singular2(resource);
      const operation = metaData?.operation ?? camelCase(resource);
      const { query: query2, variables } = gql2.mutation({
        operation,
        variables: {
          where: {
            value: { id: { in: ids } },
            type: prismaInputType.findMany(singularResource)
          }
        },
        fields: metaData?.fields
      });
      const { data } = await dataLoader.load({
        document: query2,
        variables
      });
      return {
        data: data[operation]
      };
    },
    getOne: async (info) => {
      const dataProvider = resourceDataProvider.get(info.resource);
      const customFetcher = dataProvider?.getOne;
      if (customFetcher) {
        return customFetcher({
          ...info,
          client,
          dataLoader
        });
      }
      const { resource, id, metaData } = info;
      const operation = metaData?.operation ?? camelCase(singular2(resource));
      const { query: query2, variables } = gql2.query({
        operation,
        variables: {
          id: {
            name: "id",
            type: "ID",
            value: id
          }
        },
        fields: metaData?.fields
      });
      const { data } = await dataLoader.load({ document: query2, variables });
      return {
        data: data[operation]
      };
    },
    create: async (info) => {
      const dataProvider = resourceDataProvider.get(info.resource);
      const customFetcher = dataProvider?.create;
      if (customFetcher) {
        return customFetcher({
          ...info,
          client,
          dataLoader
        });
      }
      const { resource, variables, metaData } = info;
      const singularResource = singular2(resource);
      const operation = metaData?.operation ?? camelCase(`create_one_${singularResource}`);
      const { query: query2, variables: gqlVariables } = gql2.mutation({
        operation,
        variables: {
          data: {
            value: variables,
            type: prismaInputType.create(singularResource),
            required: true
          }
        },
        fields: metaData?.fields ?? ["id"]
      });
      const response = await client.request(query2, gqlVariables);
      return {
        data: response[operation]
      };
    },
    createMany: async (info) => {
      const dataProvider = resourceDataProvider.get(info.resource);
      const customFetcher = dataProvider?.createMany;
      if (customFetcher) {
        return customFetcher({
          ...info,
          client,
          dataLoader
        });
      }
      const { resource, variables, metaData } = info;
      const singularResource = singular2(resource);
      const operation = metaData?.operation ?? camelCase(`create_many_${singularResource}`);
      const response = await Promise.all(
        variables.map(async (param) => {
          const { query: query2, variables: gqlVariables } = gql2.mutation({
            operation,
            variables: {
              input: {
                value: { data: param },
                type: prismaInputType.createMany(singularResource)
              }
            },
            fields: metaData?.fields ?? ["id"]
          });
          const result = await client.request(query2, gqlVariables);
          return result[operation];
        })
      );
      return {
        data: response
      };
    },
    update: async (info) => {
      const dataProvider = resourceDataProvider.get(info.resource);
      const customFetcher = dataProvider?.update;
      if (customFetcher) {
        return customFetcher({
          ...info,
          client,
          dataLoader
        });
      }
      const { resource, id, variables, metaData } = info;
      const singularResource = singular2(resource);
      const operation = metaData?.operation ?? camelCase(`updateOne_${singularResource}`);
      const { query: query2, variables: gqlVariables } = gql2.mutation({
        operation,
        variables: {
          where: {
            value: { id },
            type: prismaInputType.findUnique(singularResource),
            required: true
          },
          data: {
            value: variables,
            type: prismaInputType.update(singularResource),
            required: true
          }
        },
        fields: metaData?.fields ?? ["id"]
      });
      const response = await client.request(query2, gqlVariables);
      return {
        data: response[operation]
      };
    },
    updateMany: async (info) => {
      const dataProvider = resourceDataProvider.get(info.resource);
      const customFetcher = dataProvider?.updateMany;
      if (customFetcher) {
        return customFetcher({
          ...info,
          client,
          dataLoader
        });
      }
      const { resource, ids, variables, metaData } = info;
      const singularResource = singular2(resource);
      const camelUpdateName = camelCase(`update-${singularResource}`);
      const operation = metaData?.operation ?? camelUpdateName;
      const response = await Promise.all(
        ids.map(async (id) => {
          const { query: query2, variables: gqlVariables } = gql2.mutation({
            operation,
            variables: {
              input: {
                value: { where: { id }, data: variables },
                type: prismaInputType.updateMany(singularResource)
              }
            },
            fields: metaData?.fields ?? ["id"]
          });
          const result = await client.request(query2, gqlVariables);
          return result[operation];
        })
      );
      return {
        data: response
      };
    },
    deleteOne: async (info) => {
      const dataProvider = resourceDataProvider.get(info.resource);
      const customFetcher = dataProvider?.deleteOne;
      if (customFetcher) {
        return customFetcher({
          ...info,
          client,
          dataLoader
        });
      }
      const { resource, id, metaData } = info;
      const singularResource = singular2(resource);
      const operation = metaData?.operation ?? camelCase(`delete_one_${singularResource}`);
      const { query: query2, variables } = gql2.mutation({
        operation,
        variables: {
          where: {
            value: { id },
            type: prismaInputType.findUnique(singularResource),
            required: true
          }
        },
        fields: metaData?.fields ?? ["id"]
      });
      const response = await client.request(query2, variables);
      return {
        data: response[operation]
      };
    },
    deleteMany: async (info) => {
      const dataProvider = resourceDataProvider.get(info.resource);
      const customFetcher = dataProvider?.deleteMany;
      if (customFetcher) {
        return customFetcher({
          ...info,
          client,
          dataLoader
        });
      }
      const { resource, ids, metaData } = info;
      const singularResource = singular2(resource);
      const camelDeleteName = camelCase(`delete-many-${singularResource}`);
      const operation = metaData?.operation ?? camelDeleteName;
      const response = await Promise.all(
        ids.map(async (id) => {
          const { query: query2, variables: gqlVariables } = gql2.mutation({
            operation,
            variables: {
              input: {
                value: { where: { id } },
                type: prismaInputType.findFirst(singularResource)
              }
            },
            fields: metaData?.fields ?? ["id"]
          });
          const result = await client.request(query2, gqlVariables);
          return result[operation][singularResource];
        })
      );
      return {
        data: response
      };
    },
    getApiUrl: () => {
      throw Error("Not implemented on refine-graphql data provider.");
    },
    custom: async ({ method, metaData }) => {
      if (metaData) {
        if (metaData.operation) {
          if (method === "get") {
            const { query: query2, variables } = gql2.query({
              operation: metaData.operation,
              fields: metaData.fields,
              variables: metaData.variables
            });
            const response = await dataLoader.load({ document: query2, variables });
            return {
              data: response.data[metaData.operation]
            };
          } else {
            const { query: query2, variables } = gql2.mutation({
              operation: metaData.operation,
              fields: metaData.fields,
              variables: metaData.variables
            });
            const response = await dataLoader.load({ document: query2, variables });
            return {
              data: response.data[metaData.operation]
            };
          }
        } else {
          throw Error("GraphQL operation name required.");
        }
      } else {
        throw Error("GraphQL need to operation, fields and variables values in metaData object.");
      }
    }
  };
};

// src/create-event-bus.ts
import mitt from "mitt";
var createEventBus = () => mitt();

// src/create-notification-provider.ts
var createNotificationProvider = (eventBus) => {
  const notificationProvider = {
    open(params) {
      eventBus.emit("open", params);
    },
    close(key) {
      eventBus.emit("close", { key });
    }
  };
  return notificationProvider;
};

// src/lib/create-custom-page.tsx
import { isFunction as isFunction2 } from "@scalingworks/react-admin-ui";
import * as React13 from "react";
import { Helmet as Helmet2 } from "react-helmet";
var createCustomPage = (config) => {
  const title = config.title;
  return function CustomListingPage() {
    const t = useInternalTranslate();
    return /* @__PURE__ */ React13.createElement(React13.Fragment, null, /* @__PURE__ */ React13.createElement(Helmet2, null, title && /* @__PURE__ */ React13.createElement("title", null, isFunction2(title) ? title({ t }) : title)), config.render({ t }));
  };
};

// src/create-refine-admin-app.tsx
var createRefineAdminApp = ({
  graphqlUrl,
  authStorageKey = "authToken",
  resources: providedResources,
  loginHeader,
  sidebarHeader,
  sidebarCollapsedHeader,
  design: { sidebarVariant = "gray" } = {},
  userMenus,
  DashboardPage,
  i18n,
  loginDefaults = {},
  ...otherOptions
}) => {
  const loadI18nPromise = i18n && import("./setup-i18n-XTBKXNKU.mjs").then((m) => m.setupI18n(i18n));
  const resourceDataProvider = /* @__PURE__ */ new Map();
  const prefetchMap = createPrefetchMap();
  const resources = providedResources.map((r) => r({ addFieldsForCaching: prefetchMap.addFields }));
  resources.forEach((resource) => {
    if (resource.dataProvider) {
      resourceDataProvider.set(resource.name, resource.dataProvider);
    }
  });
  const getToken = () => {
    const token = localStorage.getItem(authStorageKey);
    if (token) {
      try {
        return token;
      } catch (e) {
        return null;
      }
    }
    return null;
  };
  const graphqlClient = new GraphQLClient(graphqlUrl, {
    headers: () => {
      const token = getToken();
      return token ? {
        Authorization: `Bearer ${token}`
      } : {};
    }
  });
  const authProvider = otherOptions.authProvider || createAuthProvider({
    authStorageKey,
    graphqlClient
  });
  const dataLoader = new DataLoader(
    (documents) => {
      return graphqlClient.batchRequests(documents);
    },
    {
      cache: false
      // use react-query for caching instead
    }
  );
  const dataProvider = otherOptions.dataProvider?.(resourceDataProvider, dataLoader) || createDataProvider(graphqlClient, resourceDataProvider, dataLoader);
  const eventBus = createEventBus();
  const notificationProvider = createNotificationProvider(eventBus);
  prefetchMap.seal();
  const refineOptions = {
    ...otherOptions,
    DashboardPage: DashboardPage && createCustomPage(DashboardPage),
    dataProvider,
    authProvider,
    Header,
    Layout: createLayout({
      sidebarHeader,
      sidebarCollapsedHeader,
      sidebarVariant,
      userMenus,
      DashboardPage,
      i18n,
      prefetchMap,
      accessConfig: otherOptions.accessConfig,
      quickActions: otherOptions.quickActions
    }),
    LoginPage: otherOptions.LoginPage ? createCustomPage(otherOptions.LoginPage) : createLoginPage({
      header: loginHeader,
      i18n,
      defaultUsername: loginDefaults.userName,
      defaultPassword: loginDefaults.password
    }),
    resources,
    notificationProvider,
    accessControlProvider: otherOptions?.accessControlProvider || createAccessControlProvider(authProvider, {
      refreshIntervalMs: 1e3 * 60
      // refresh every minute
    }),
    catchAll: otherOptions.errorPage
  };
  const Provider = createProvider({
    eventBus,
    graphqlClient,
    waitForPromise: loadI18nPromise
  });
  return () => /* @__PURE__ */ React14.createElement(RefineAdminApp, { refine: refineOptions, Provider, i18n });
};

// src/components/create-default-show-page.tsx
import { useDelete as useDelete2, useNavigation as useNavigation3, useTranslate as useTranslate8 } from "@refinedev/core";
import {
  AlertDialog,
  Button as Button7,
  IconButton as IconButton3,
  isString as isString5
} from "@scalingworks/react-admin-ui";
import * as React45 from "react";
import { JsonPrettyViewer } from "react-json-friendly-viewer";

// src/hooks/use-get-resource-label.ts
import { useTranslate as useTranslate3 } from "@refinedev/core";
import { capitalCase } from "change-case";
import { plural as plural2, singular as singular3 } from "pluralize";
import * as React15 from "react";
var useGetResourceLabel = (resourceName) => {
  const translate = useTranslate3();
  return React15.useCallback(
    (providedLabel, { type, capitalize }) => {
      const format = {
        singular: singular3,
        plural: plural2
      }[type];
      if (providedLabel) {
        return format(providedLabel);
      }
      return translate(
        `${resourceName}.${resourceName}`,
        { count: type === "singular" ? 1 : 2 },
        function getFallbackText(resource) {
          if (capitalize) {
            return capitalCase(format(resource));
          }
          return format(resource);
        }(resourceName)
      );
    },
    [resourceName]
  );
};

// src/components/resource-card-section.tsx
import { useShow as useShow2 } from "@refinedev/core";
import {
  Card as Card2,
  DescList,
  formatDate,
  formatStringList,
  isFunction as isFunction3,
  isObject as isObject4,
  isString as isString3
} from "@scalingworks/react-admin-ui";
import * as React34 from "react";

// src/lib/inference.ts
import { sentenceCase } from "change-case";
var inferLabelFromName = (name) => sentenceCase(name);

// src/components/resource-card-section-edit-button.tsx
import { useForm as useForm2 } from "@refinedev/react-hook-form";
import { Button as Button3, Dialog as Dialog2, isNil as isNil2, isObject as isObject3 } from "@scalingworks/react-admin-ui";
import * as React33 from "react";
import { HiPencil } from "react-icons/hi";

// src/modules/form/components/dynamic-form.tsx
import { Button as Button2, Card, NumberField as NumberField2, isNumber } from "@scalingworks/react-admin-ui";
import { clsx as clsx4 } from "clsx";
import * as React32 from "react";
import { useController as useController2, useFieldArray, useWatch } from "react-hook-form";
import { HiX } from "react-icons/hi";

// src/lib/graphql.ts
var isGraphqlError = (error) => !!error && typeof error === "object" && "request" in error && "response" in error && Array.isArray(error.response.errors);
var extractGraphqlErrors = (error) => {
  if (isGraphqlError(error)) {
    return (error.response.errors ?? []).map((err) => {
      let errMessage = err.message;
      let path;
      if (err.extensions.response?.errors) {
        for (const innerError of err.extensions.response.errors) {
          if (innerError && innerError.message) {
            errMessage = innerError.message;
            if (innerError.path) {
              path = innerError.path;
            }
          }
        }
      }
      return { message: errMessage, path };
    });
  }
  return void 0;
};

// src/modules/form/form.lib.ts
import { useController } from "react-hook-form";
import { isDefined, isNil, isObject, isString as isString2 } from "@scalingworks/react-admin-ui";
import * as React16 from "react";
var inferControlConfig = (defaultValue, name, componentConfigDefaults) => {
  if (isNil(defaultValue)) {
    return;
  }
  switch (typeof defaultValue) {
    case "string":
      return {
        type: "text",
        config: {
          ...componentConfigDefaults,
          label: inferLabelFromName(name)
        }
      };
    case "boolean":
      return {
        type: "switch",
        config: {
          ...componentConfigDefaults,
          label: inferLabelFromName(name)
        }
      };
    case "number":
      return {
        type: "number",
        config: {
          ...componentConfigDefaults,
          label: inferLabelFromName(name)
        }
      };
    default:
      break;
  }
  return;
};
var deriveControls = (defaultValues, controlsOverride = {}, inferSections, forceHideLabel) => {
  const {
    components = {},
    componentConfigDefaults: globalConfigDefaults = {},
    sections
  } = controlsOverride;
  const controls = [];
  const seenControls = /* @__PURE__ */ new Set();
  const groupMap = /* @__PURE__ */ new Map();
  const addToGroup = (group, item) => {
    const currentItems = groupMap.get(group);
    if (currentItems) {
      currentItems.push(item);
    } else {
      groupMap.set(group, [item]);
    }
  };
  const ungroupedItems = [];
  function computeSectionGroupAndConfig(fieldName) {
    if (sections) {
      for (const group of sections) {
        const matchedConfig = group.items.find(
          (sectionItem) => isString2(sectionItem) ? sectionItem === fieldName : sectionItem.field === fieldName
        );
        if (matchedConfig) {
          return {
            group,
            getItem: (item) => isString2(matchedConfig) ? {
              control: item,
              span: 1
            } : {
              control: item,
              span: matchedConfig.span
            }
          };
        }
      }
    }
    return void 0;
  }
  function computeControl(name, defaultValue, fieldPrefixes) {
    const fieldName = [...fieldPrefixes, name].join(".");
    seenControls.add(fieldName);
    const providedComponent = components[fieldName];
    const groupAndConfig = computeSectionGroupAndConfig(fieldName);
    const componentConfigDefaults = groupAndConfig?.group.componentConfigDefaults ?? globalConfigDefaults;
    if (!isNil(providedComponent)) {
      if (providedComponent !== false) {
        if (!Array.isArray(providedComponent) && isObject(providedComponent) && "component" in providedComponent) {
          const customControl = {
            name: fieldName,
            definition: {
              required: componentConfigDefaults.required,
              ...providedComponent
            },
            defaultValue,
            label: providedComponent.label
          };
          controls.push(customControl);
          if (groupAndConfig) {
            addToGroup(groupAndConfig.group, groupAndConfig.getItem(customControl));
          } else {
            ungroupedItems.push({
              control: customControl,
              span: 1
            });
          }
        } else if (Array.isArray(providedComponent)) {
          const [
            innerControls,
            { label = "", required = componentConfigDefaults.required, ...validation } = {}
          ] = providedComponent;
          const [defaultInnerValues] = Array.isArray(defaultValue) ? defaultValue : [];
          controls.push({
            name: fieldName,
            validation: {
              ...validation,
              required
            },
            label,
            defaultValue: defaultInnerValues,
            children: deriveControls(
              defaultInnerValues ?? {},
              {
                components: innerControls,
                componentConfigDefaults
              },
              inferSections,
              true
            ).controls
          });
        } else {
          const control = providedComponent;
          const item = {
            name: fieldName,
            definition: "component" in control ? {
              required: componentConfigDefaults.required,
              ...control
            } : {
              ...control,
              config: {
                hideLabel: forceHideLabel,
                ...componentConfigDefaults,
                ...control.config
              }
            },
            defaultValue,
            label: "component" in control ? control.label : control.config.label
          };
          controls.push(item);
          if (groupAndConfig) {
            addToGroup(groupAndConfig.group, groupAndConfig.getItem(item));
          } else {
            ungroupedItems.push({
              control: item,
              span: 1
            });
          }
        }
      }
    } else {
      if (isObject(defaultValue) && !Array.isArray(defaultValue)) {
        Object.entries(defaultValue).forEach(
          ([innerField, innerDefaultValue]) => computeControl(innerField, innerDefaultValue, fieldPrefixes.concat(name))
        );
      } else {
        const nameParts = name.split(".");
        const inferredControl = inferControlConfig(defaultValue, nameParts[nameParts.length - 1], {
          hideLabel: forceHideLabel,
          ...componentConfigDefaults
        });
        if (inferredControl) {
          const item = {
            name: fieldName,
            definition: inferredControl,
            label: inferredControl.config.label,
            defaultValue
          };
          controls.push(item);
          if (groupAndConfig) {
            addToGroup(groupAndConfig.group, groupAndConfig.getItem(item));
          } else {
            ungroupedItems.push({
              control: item,
              span: 1
            });
          }
        }
      }
    }
  }
  Object.entries(defaultValues).forEach(
    ([name, defaultValue]) => computeControl(name, defaultValue, [])
  );
  Object.entries(components).forEach(([name, providedConfig]) => {
    if (seenControls.has(name)) {
      return;
    }
    const controlConfig = providedConfig;
    if (controlConfig) {
      const groupAndConfig = computeSectionGroupAndConfig(name);
      const componentConfigDefaults = groupAndConfig?.group.componentConfigDefaults ?? globalConfigDefaults;
      const item = {
        name,
        definition: "component" in controlConfig ? {
          required: componentConfigDefaults.required,
          ...controlConfig
        } : {
          ...controlConfig,
          config: {
            hideLabel: forceHideLabel,
            ...componentConfigDefaults,
            ...controlConfig.config
          }
        },
        label: "component" in controlConfig ? controlConfig.label : controlConfig.config.label
      };
      controls.push(item);
      if (groupAndConfig) {
        addToGroup(groupAndConfig.group, groupAndConfig.getItem(item));
      } else {
        ungroupedItems.push({
          control: item,
          span: 1
        });
      }
    }
  });
  const groups = Array.from(
    groupMap,
    ([group, items]) => ({
      items,
      title: group.title,
      index: sections && sections.indexOf(group)
    })
  ).sort((a, b) => {
    if (a.index && b.index) {
      return a.index - b.index;
    }
    return 0;
  });
  return sections || inferSections ? {
    renderItems: ungroupedItems.length > 0 ? groups.concat({
      items: ungroupedItems
    }) : groups,
    controls
  } : {
    renderItems: controls,
    controls
  };
};
var getControlRules = (props) => ({
  required: props.required,
  minLength: props.minLength && {
    value: props.minLength,
    message: `must be at least ${props.minLength} character`
  },
  max: isDefined(props.max) ? {
    value: props.max,
    message: `must be less than ${props.max}`
  } : void 0,
  min: isDefined(props.min) ? {
    value: props.min,
    message: `must be at least ${props.min}`
  } : void 0,
  pattern: isDefined(props.pattern) && !isString2(props.pattern) ? {
    value: props.pattern,
    message: `is not following required format`
  } : void 0
});
var ArrayFieldContext = React16.createContext(void 0);
ArrayFieldContext.displayName = "ArrayFieldContext";
var useFormField = (options) => {
  const arrayField = React16.useContext(ArrayFieldContext);
  return useController({
    ...options,
    name: arrayField ? `${arrayField.name}.${arrayField.index}.${options.name}` : options.name
  });
};

// src/modules/form/components/form.tsx
import * as React31 from "react";
import { FormProvider } from "react-hook-form";

// src/modules/form/components/form-checkbox-field.tsx
import { CheckboxField } from "@scalingworks/react-admin-ui";
import * as React17 from "react";
var FormCheckboxField = ({
  defaultValue,
  label,
  hideLabel,
  ...props
}) => {
  const controller = useFormField({
    name: props.name,
    rules: getControlRules(props),
    defaultValue
  });
  const error = controller.fieldState.error;
  return /* @__PURE__ */ React17.createElement(
    CheckboxField,
    {
      status: error ? "danger" : void 0,
      ...props,
      ...hideLabel ? {
        "aria-label": label
      } : {
        label
      },
      value: controller.field.value,
      name: controller.field.name,
      onValue: controller.field.onChange,
      ref: controller.field.ref
    }
  );
};

// src/modules/form/components/form-date-range-field.tsx
import { DateRangeField } from "@scalingworks/react-admin-ui";
import * as React18 from "react";
var FormDateRangeField = ({
  defaultValue,
  label,
  hideLabel,
  ...props
}) => {
  const controller = useFormField({
    name: props.name,
    rules: getControlRules(props),
    defaultValue
  });
  const error = controller.fieldState.error;
  return /* @__PURE__ */ React18.createElement(
    DateRangeField,
    {
      status: error ? "danger" : void 0,
      ...props,
      ...hideLabel ? {
        "aria-label": label
      } : {
        label
      },
      value: controller.field.value,
      name: controller.field.name,
      onValue: controller.field.onChange,
      ref: controller.field.ref
    }
  );
};

// src/modules/form/components/form-day-field.tsx
import { DayField } from "@scalingworks/react-admin-ui";
import * as React19 from "react";
var FormDayField = ({ defaultValue, label, hideLabel, ...props }) => {
  const controller = useFormField({
    name: props.name,
    rules: getControlRules({
      required: props.required
    }),
    defaultValue
  });
  const error = controller.fieldState.error;
  return /* @__PURE__ */ React19.createElement(
    DayField,
    {
      status: error ? "danger" : void 0,
      ...props,
      ...hideLabel ? {
        "aria-label": label
      } : {
        label
      },
      value: controller.field.value,
      name: controller.field.name,
      onValue: controller.field.onChange,
      ref: controller.field.ref
    }
  );
};

// src/modules/form/components/form-error-alert.tsx
import { Alert, isObject as isObject2 } from "@scalingworks/react-admin-ui";
import * as React20 from "react";
import { useFormContext } from "react-hook-form";

// src/lib/scroll.ts
var scrollIntoView = (target, options) => {
  import("scroll-into-view-if-needed").then((m) => {
    const scroll = m.default;
    if (target.isConnected) {
      scroll(target, options);
    }
  });
};

// src/modules/form/components/form-error-alert.tsx
var FormErrorAlert = (props) => {
  const { formState } = useFormContext();
  const controlLabelByName = React20.useMemo(
    () => new Map(props.controlConfigs.map((config) => [config.name, config.label])),
    [props.controlConfigs]
  );
  const formErrors = formatErrors(formState.errors, controlLabelByName);
  const allErrors = props.additionalErrors ? props.additionalErrors.concat(formErrors) : formErrors;
  return allErrors.length > 0 ? /* @__PURE__ */ React20.createElement(Alert, { type: "danger" }, /* @__PURE__ */ React20.createElement("ul", { className: "list-none" }, allErrors.map((err, index) => /* @__PURE__ */ React20.createElement("li", { className: "text-sm", key: index }, err.path ? /* @__PURE__ */ React20.createElement(
    "button",
    {
      onClick: () => {
        const target = document.querySelector(`[name="${err.path}"]`);
        if (target) {
          scrollIntoView(target, {
            scrollMode: "if-needed",
            behavior: "smooth"
          });
        }
      },
      type: "button",
      className: "hover:underline"
    },
    err.message
  ) : err.message)))) : null;
};
var formatErrors = (formErrors, labelByName) => {
  if (!formErrors) {
    return [];
  }
  const results = [];
  Object.entries(formErrors).forEach((entry) => {
    const [fieldName, error] = entry;
    if (error) {
      collectErrorMessage(error, labelByName, fieldName, [], results);
    }
  });
  return results;
};
var collectErrorMessage = (error, labelByName, fieldName, fieldPrefixes, result) => {
  if ("type" in error) {
    const path = [...fieldPrefixes, fieldName].join(".");
    const label = labelByName.get(path) || fieldName;
    if (error.type === "required") {
      result.push({ message: `${label} is required.`, path });
    } else if ((error.type === "minLength" || error.type === "max" || error.type === "min" || error.type === "pattern") && error.message) {
      result.push({ message: `${label} ${error.message}.`, path });
    } else if (error.type === "server" && error.message) {
      result.push({ message: error.message, path });
    } else {
      console.error({ error });
    }
  } else if (isObject2(error)) {
    const innerFieldPrefixes = fieldPrefixes.concat(fieldName);
    Object.entries(error).forEach(([innerField, innerError]) => {
      collectErrorMessage(
        innerError,
        labelByName,
        innerField,
        innerFieldPrefixes,
        result
      );
    });
  }
};

// src/modules/form/components/form-file-list-field.tsx
import {
  FieldGroup,
  FileItem,
  FileUpload,
  Label,
  RemoteFileItem,
  formatDateUtc,
  useIdUtils as useIdUtils2
} from "@scalingworks/react-admin-ui";
import * as React22 from "react";
import { v4 as uuid } from "uuid";

// src/hooks/use-file-uploads.ts
import { useConstant, usePrevious, useStableCallback } from "@reach/utils";
import {
  isSimilarArray as isSimilarArray2,
  pickAndOmit,
  useIdUtils,
  useIsMounted
} from "@scalingworks/react-admin-ui";
import * as React21 from "react";
import { createRequest } from "xhfetch";

// src/hooks/use-make-presigned-url.ts
import { useCustomMutation } from "@refinedev/core";
var useMakePresignedUrl = () => {
  const { mutate, mutateAsync, ...rest } = useCustomMutation();
  return {
    ...rest,
    invoke: (value) => mutateAsync({
      method: "post",
      url: "",
      values: {},
      metaData: {
        operation: "generatePresignedFile",
        fields: ["url", "signedUrl", "path", "name"],
        variables: {
          data: {
            type: "GeneratePresignedFileInput",
            required: true,
            value
          }
        }
      }
    }).then((result) => result.data)
  };
};

// src/hooks/use-file-uploads.ts
var useFileUploads = ({
  uploadOperation,
  validateBeforeUpload,
  onChange,
  maxCount,
  purpose,
  allowChangeAlt
}) => {
  const isMounted = useIsMounted();
  const cancelMap = useConstant(() => /* @__PURE__ */ new WeakMap());
  const { invoke: getPresignedUrl } = useMakePresignedUrl();
  const runUploadMap = useConstant(() => /* @__PURE__ */ new WeakMap());
  const [state, dispatch] = React21.useReducer(fileUploadReducer, {
    items: []
  });
  const stateValue = state;
  const cancelInflightRequests = useStableCallback(() => {
    state.items.forEach((item) => {
      const cancel = cancelMap.get(item.file);
      if (cancel) {
        cancel();
      }
    });
  });
  React21.useEffect(() => cancelInflightRequests, [cancelInflightRequests]);
  const { getId } = useIdUtils();
  const removeItem = (item) => {
    const file = item.file;
    const cancel = cancelMap.get(file);
    if (cancel) {
      cancel();
    }
    cancelMap.delete(file);
    runUploadMap.delete(file);
    dispatch({
      type: "remove",
      file
    });
  };
  const addFile = useStableCallback((file) => {
    if (maxCount && maxCount === stateValue.items.length && stateValue.items.length > 0) {
      removeItem(stateValue.items[0]);
    }
    const validationResult = validateBeforeUpload && validateBeforeUpload(file);
    if (validationResult) {
      dispatch({
        type: "addFile",
        file,
        key: getId(),
        errorMessage: validationResult
      });
      return;
    }
    if (uploadOperation === "local") {
      dispatch({
        type: "addLocalFile",
        file,
        key: getId()
      });
      return;
    }
    const runUpload = () => {
      getPresignedUrl({
        fileName: file.name,
        purpose
      }).then((result) => {
        if (isMounted.current) {
          if (result) {
            const { signedUrl, url } = result;
            const req = createRequest(signedUrl, {
              method: "PUT",
              body: file
            });
            req.xhr.upload.addEventListener(
              "progress",
              (ev) => dispatch({
                type: "fileUploadProgress",
                uploadProgress: ev.loaded / ev.total,
                file
              })
            );
            cancelMap.set(file, () => req.xhr.abort());
            return req.fetch().then((finalResult) => {
              if (finalResult.ok) {
                dispatch({
                  type: "completeUpload",
                  file,
                  result: url
                });
              } else {
                dispatch({
                  type: "error",
                  file
                });
              }
            });
          } else {
            dispatch({
              type: "error",
              file
            });
          }
        }
      }).catch(
        () => dispatch({
          type: "error",
          file
        })
      );
    };
    runUpload();
    runUploadMap.set(file, runUpload);
    dispatch({
      type: "addFile",
      file,
      key: getId()
    });
  });
  const uploadResults = [];
  const items = [];
  stateValue.items.forEach((item) => {
    switch (item.uploadStatus) {
      case "completed":
        {
          const {
            picked: { result },
            omitted: itemResult
          } = pickAndOmit(item, ["result"]);
          if (result) {
            uploadResults.push({
              url: result,
              file: itemResult.file,
              alt: itemResult.alt,
              _key: itemResult.key
            });
          }
          items.push({
            ...itemResult,
            onRemove: () => removeItem(item),
            onRetry: void 0,
            onAltChange: allowChangeAlt ? (newAlt) => dispatch({
              type: "altChange",
              file: item.file,
              alt: newAlt
            }) : void 0
          });
        }
        break;
      case "error":
        {
          const {
            picked: { noRetry },
            omitted: itemResult
          } = pickAndOmit(item, ["noRetry"]);
          items.push({
            ...itemResult,
            onRemove: () => removeItem(item),
            onRetry: noRetry ? void 0 : () => {
              const file = item.file;
              dispatch({
                type: "retry",
                file
              });
              const runUpload = runUploadMap.get(file);
              if (runUpload) {
                runUpload();
              }
            }
          });
        }
        break;
      case "uploading":
        items.push({
          ...item,
          onRemove: () => removeItem(item),
          onRetry: void 0
        });
        break;
      default:
        break;
    }
  });
  const results = uploadOperation === "local" ? items.filter((item) => item.uploadStatus === "completed").map((item) => item.file) : uploadResults;
  const previousResults = usePrevious(results);
  React21.useEffect(() => {
    if (onChange && previousResults && !isSimilarArray2(
      previousResults,
      results,
      uploadOperation === "local" ? void 0 : ["_key", "alt"]
    )) {
      onChange(results);
    }
  });
  return {
    addFile: (fileOrFiles) => {
      const files = Array.isArray(fileOrFiles) ? fileOrFiles : [fileOrFiles];
      files.forEach((file) => addFile(file));
    },
    results: uploadOperation === "local" ? results : uploadResults,
    items,
    hasPendingRequest: uploadOperation === "local" ? false : stateValue.items.some((item) => item.uploadStatus === "uploading")
  };
};
var fileUploadReducer = (state, action) => {
  switch (action.type) {
    case "addFile":
      return {
        ...state,
        items: state.items.concat({
          file: action.file,
          alt: action.file.name,
          uploadStatus: action.errorMessage ? "error" : "uploading",
          errorMessage: action.errorMessage,
          uploadProgress: 0,
          key: action.key,
          ...action.errorMessage ? { noRetry: true } : {}
        })
      };
    case "addLocalFile":
      return {
        ...state,
        items: state.items.concat({
          file: action.file,
          alt: action.file.name,
          uploadStatus: "completed",
          key: action.key
        })
      };
    case "fileUploadProgress":
      return {
        ...state,
        items: state.items.map(
          (item) => item.file === action.file && item.uploadStatus === "uploading" ? {
            ...item,
            uploadProgress: action.uploadProgress
          } : item
        )
      };
    case "completeUpload":
      return {
        ...state,
        items: state.items.map(
          (item) => item.file === action.file && item.uploadStatus === "uploading" ? {
            ...item,
            uploadProgress: 100,
            uploadStatus: "completed",
            result: action.result
          } : item
        )
      };
    case "error":
      return {
        ...state,
        items: state.items.map(
          (item) => item.file === action.file && item.uploadStatus === "uploading" ? {
            ...item,
            uploadStatus: "error",
            errorMessage: action.errorMessage
          } : item
        )
      };
    case "remove":
      return {
        ...state,
        items: state.items.filter((item) => item.file !== action.file)
      };
    case "retry":
      return {
        ...state,
        items: state.items.map(
          (item) => item.file === action.file && item.uploadStatus === "error" ? {
            ...item,
            uploadStatus: "uploading",
            uploadProgress: 0,
            errorMessage: void 0
          } : item
        )
      };
    case "altChange":
      return {
        ...state,
        items: state.items.map(
          (item) => item.file === action.file ? {
            ...item,
            alt: action.alt
          } : item
        )
      };
    default:
      throw new Error(`Unsupported action: ${JSON.stringify(action)}`);
  }
};

// src/modules/form/components/form-file-list-field.tsx
var FormFileListField = ({
  defaultValue,
  label,
  hideLabel,
  purpose,
  max,
  uploadLabel,
  allowChangeAlt,
  ...props
}) => {
  const [baseId] = React22.useState(() => uuid());
  const { getId } = useIdUtils2();
  const { field, fieldState } = useFormField({
    name: props.name,
    rules: getControlRules({
      required: props.required,
      max
    }),
    defaultValue
  });
  const fieldValue = Array.isArray(field.value) ? field.value : [];
  const remoteItems = fieldValue.filter(
    (fieldItem) => !fieldItem.id || !fieldItem.id.startsWith(baseId)
  );
  const { addFile, items } = useFileUploads({
    uploadOperation: "instant",
    maxCount: max,
    purpose,
    allowChangeAlt,
    onChange: (uploadResults) => {
      field.onChange(
        remoteItems.concat(
          uploadResults.map(
            (upload) => fieldValue.find(
              (fieldItem) => fieldItem.url === upload.url && fieldItem.alt === upload.alt
            ) || {
              url: upload.url,
              alt: upload.alt,
              createdAt: formatDateUtc(/* @__PURE__ */ new Date()),
              id: `${baseId}_${getId()}`
            }
          )
        )
      );
    }
  });
  const error = fieldState.error;
  return /* @__PURE__ */ React22.createElement(FieldGroup, { fieldId: props.id, status: error ? "danger" : void 0 }, label && !hideLabel && /* @__PURE__ */ React22.createElement(Label, { showRequiredIndicator: props.required }, label), /* @__PURE__ */ React22.createElement("div", { className: "flex-1" }, /* @__PURE__ */ React22.createElement(FileUpload, { ...props, onFilesSelected: addFile, label: uploadLabel, ref: field.ref }), /* @__PURE__ */ React22.createElement("div", { className: "flex flex-wrap gap-5 p-3" }, remoteItems.map((remoteItem) => /* @__PURE__ */ React22.createElement(
    RemoteFileItem,
    {
      url: remoteItem.url,
      alt: remoteItem.alt,
      onAltChange: allowChangeAlt ? (newAlt) => field.onChange(
        fieldValue.map(
          (item) => item === remoteItem ? {
            ...item,
            alt: newAlt
          } : item
        )
      ) : void 0,
      onRemove: () => field.onChange(fieldValue.filter((v) => v !== remoteItem)),
      className: "p-1 shadow",
      disabled: props.disabled,
      key: remoteItem.id
    }
  )), items.map((item) => /* @__PURE__ */ React22.createElement(FileItem, { ...item, className: "p-1 shadow" })))));
};

// src/modules/form/components/form-number-field.tsx
import { NumberField } from "@scalingworks/react-admin-ui";
import * as React23 from "react";
var FormNumberField = ({
  defaultValue,
  label,
  hideLabel,
  ...props
}) => {
  const controller = useFormField({
    name: props.name,
    rules: getControlRules(props),
    defaultValue
  });
  const error = controller.fieldState.error;
  return /* @__PURE__ */ React23.createElement(
    NumberField,
    {
      status: error ? "danger" : void 0,
      ...props,
      ...controller.field,
      ...hideLabel ? {
        "aria-label": label
      } : {
        label
      },
      value: controller.field.value || ""
    }
  );
};

// src/modules/form/components/form-password-field.tsx
import { PasswordField as PasswordField2 } from "@scalingworks/react-admin-ui";
import * as React24 from "react";
var FormPasswordField = ({
  defaultValue,
  label,
  hideLabel,
  ...props
}) => {
  const controller = useFormField({
    name: props.name,
    rules: getControlRules(props),
    defaultValue
  });
  const error = controller.fieldState.error;
  return /* @__PURE__ */ React24.createElement(
    PasswordField2,
    {
      status: error ? "danger" : void 0,
      ...props,
      ...controller.field,
      ...hideLabel ? {
        "aria-label": label
      } : {
        label
      },
      value: controller.field.value || ""
    }
  );
};

// src/modules/form/components/form-phone-field.tsx
import { PhoneField } from "@scalingworks/react-admin-ui";
import * as React25 from "react";
var FormPhoneField = ({
  defaultValue,
  label,
  hideLabel,
  ...props
}) => {
  const controller = useFormField({
    name: props.name,
    rules: getControlRules(props),
    defaultValue
  });
  const error = controller.fieldState.error;
  return /* @__PURE__ */ React25.createElement(
    PhoneField,
    {
      status: error ? "danger" : void 0,
      ...props,
      ...controller.field,
      onValue: controller.field.onChange,
      ...hideLabel ? {
        "aria-label": label
      } : {
        label
      },
      value: controller.field.value || ""
    }
  );
};

// src/modules/form/components/form-resource-checkbox-field.tsx
import { Skeleton as Skeleton2 } from "@scalingworks/react-admin-ui";
import * as React26 from "react";

// src/hooks/use-resource-select.ts
import { useSelect } from "@refinedev/core";
var useResourceSelect = (props) => useSelect(props);

// src/modules/form/components/form-resource-checkbox-field.tsx
var FormResourceCheckboxField = ({
  resourceName,
  fields,
  optionLabel,
  optionValue,
  ...checkboxProps
}) => {
  const { options, queryResult } = useResourceSelect({
    resource: resourceName,
    metaData: {
      fields
    },
    optionLabel,
    optionValue
  });
  return /* @__PURE__ */ React26.createElement(
    FormCheckboxField,
    {
      ...checkboxProps,
      options: options.length === 0 && queryResult.isFetching ? [
        {
          value: "",
          label: "Loading...",
          displayLabel: /* @__PURE__ */ React26.createElement(Skeleton2, { heightClass: "h-5", width: "medium" })
        },
        { value: "", label: "Loading...", displayLabel: /* @__PURE__ */ React26.createElement(Skeleton2, { heightClass: "h-5" }) }
      ] : options
    }
  );
};

// src/modules/form/components/form-resource-select-field.tsx
import * as React28 from "react";

// src/modules/form/components/form-select-field.tsx
import { SelectField } from "@scalingworks/react-admin-ui";
import * as React27 from "react";
var FormSelectField = ({
  defaultValue,
  label,
  hideLabel,
  ...props
}) => {
  const controller = useFormField({
    name: props.name,
    rules: getControlRules(props),
    defaultValue
  });
  const error = controller.fieldState.error;
  return /* @__PURE__ */ React27.createElement(
    SelectField,
    {
      status: error ? "danger" : void 0,
      ...props,
      ...controller.field,
      onValue: controller.field.onChange,
      ...hideLabel ? {
        "aria-label": label
      } : {
        label
      }
    }
  );
};

// src/modules/form/components/form-resource-select-field.tsx
var FormResourceSelectField = ({
  resourceName,
  fields,
  optionLabel,
  optionValue,
  ...selectProps
}) => {
  const { options } = useResourceSelect({
    resource: resourceName,
    metaData: {
      fields
    },
    optionLabel,
    optionValue
  });
  return /* @__PURE__ */ React28.createElement(FormSelectField, { ...selectProps, options });
};

// src/modules/form/components/form-switch-field.tsx
import { SwitchField } from "@scalingworks/react-admin-ui";
import * as React29 from "react";
var FormSwitchField = ({
  defaultValue,
  label,
  hideLabel,
  ...props
}) => {
  const controller = useFormField({
    name: props.name,
    rules: getControlRules(props),
    defaultValue
  });
  const error = controller.fieldState.error;
  return /* @__PURE__ */ React29.createElement(
    SwitchField,
    {
      status: error ? "danger" : void 0,
      ...props,
      ...controller.field,
      ...hideLabel ? {
        "aria-label": label
      } : {
        label
      }
    }
  );
};

// src/modules/form/components/form-text-field.tsx
import { TextField as TextField3 } from "@scalingworks/react-admin-ui";
import * as React30 from "react";
var FormTextField = ({ defaultValue, label, hideLabel, ...props }) => {
  const controller = useFormField({
    name: props.name,
    rules: getControlRules(props),
    defaultValue
  });
  const error = controller.fieldState.error;
  return /* @__PURE__ */ React30.createElement(
    TextField3,
    {
      status: error ? "danger" : void 0,
      ...props,
      ...controller.field,
      ...hideLabel ? {
        "aria-label": label
      } : {
        label
      },
      value: controller.field.value || ""
    }
  );
};

// src/modules/form/components/form.tsx
var FormImpl = React31.forwardRef(function Form({ form, ...props }, forwardedRef) {
  return /* @__PURE__ */ React31.createElement(FormProvider, { ...form }, /* @__PURE__ */ React31.createElement("form", { ...props, ref: forwardedRef }));
});
var Form2 = Object.assign(FormImpl, {
  CheckboxField: FormCheckboxField,
  DayField: FormDayField,
  DateRangeField: FormDateRangeField,
  FileListField: FormFileListField,
  NumberField: FormNumberField,
  PasswordField: FormPasswordField,
  PhoneField: FormPhoneField,
  ResourceCheckboxField: FormResourceCheckboxField,
  ResourceSelectField: FormResourceSelectField,
  SelectField: FormSelectField,
  SwitchField: FormSwitchField,
  TextField: FormTextField,
  ErrorAlert: FormErrorAlert
});

// src/modules/form/components/dynamic-form.tsx
var DynamicForm = ({
  form,
  inferSections,
  defaultValues,
  controls: providedControls,
  formatBeforeSubmit,
  submitText = "Submit",
  id
}) => {
  const { controls, renderItems } = React32.useMemo(
    () => deriveControls(defaultValues, providedControls, inferSections),
    [defaultValues, providedControls, inferSections]
  );
  const serverErrors = React32.useMemo(
    () => form.refineCore.mutationResult.isError ? extractGraphqlErrors(form.refineCore.mutationResult.error) : void 0,
    [form.refineCore.mutationResult.isError, form.refineCore.mutationResult.error]
  );
  React32.useEffect(() => {
    const serverErrorsWithPaths = serverErrors?.filter((err) => !!err.path);
    if (serverErrorsWithPaths && serverErrorsWithPaths.length > 0) {
      serverErrorsWithPaths.forEach(
        (err) => err.path && form.setError(err.path, {
          message: err.message,
          type: "server"
        })
      );
    }
  }, [serverErrors]);
  const serverErrorsWithoutPaths = React32.useMemo(
    () => serverErrors && serverErrors.filter((err) => !err.path),
    [serverErrors]
  );
  return /* @__PURE__ */ React32.createElement(
    Form2,
    {
      onSubmit: form.handleSubmit((values) => {
        const fieldValues = preFormat(values, controls, defaultValues);
        if (formatBeforeSubmit) {
          return Promise.resolve(formatBeforeSubmit(fieldValues)).then(form.refineCore.onFinish);
        }
        return form.refineCore.onFinish(fieldValues);
      }),
      form,
      className: "flex flex-col gap-3",
      id,
      noValidate: true
    },
    /* @__PURE__ */ React32.createElement(Form2.ErrorAlert, { controlConfigs: controls, additionalErrors: serverErrorsWithoutPaths }),
    renderItems.map(function renderFormItem(control, index) {
      if ("children" in control) {
        return /* @__PURE__ */ React32.createElement(
          FormListField,
          {
            name: control.name,
            label: control.label,
            items: control.children,
            defaultValue: control.defaultValue,
            validation: control.validation,
            disabled: form.refineCore.formLoading,
            key: control.name
          }
        );
      }
      if ("items" in control) {
        return /* @__PURE__ */ React32.createElement(Card, { key: `items-${index}` }, control.title && /* @__PURE__ */ React32.createElement(Card.Header, { bordered: true }, control.title), /* @__PURE__ */ React32.createElement(Card.Body, null, /* @__PURE__ */ React32.createElement("div", { className: "@container/formitems" }, /* @__PURE__ */ React32.createElement("div", { className: "grid gap-5 @md/formitems:grid-cols-2 @md/formitems:gap-x-10" }, control.items.map((item, i) => /* @__PURE__ */ React32.createElement(
          "div",
          {
            className: clsx4("block", item.span === 2 && "@md/formitems:col-span-2"),
            key: i
          },
          renderFormItem(item.control, i)
        ))))));
      }
      return "component" in control.definition ? /* @__PURE__ */ React32.createElement(
        CustomControl,
        {
          name: control.name,
          definition: control.definition,
          disabled: form.refineCore.formLoading,
          defaultValue: control.defaultValue,
          defaultValues,
          key: control.name
        }
      ) : /* @__PURE__ */ React32.createElement(
        BuiltInControl,
        {
          name: control.name,
          config: control.definition,
          defaultValue: control.defaultValue,
          disabled: form.refineCore.formLoading,
          key: control.name
        }
      );
    }),
    submitText === false ? null : /* @__PURE__ */ React32.createElement(
      Button2,
      {
        variant: "solid",
        className: "w-full",
        loading: form.refineCore.mutationResult.isLoading,
        disabled: form.refineCore.formLoading,
        type: "submit"
      },
      submitText
    )
  );
};
var preFormat = (fieldValues, controls, defaultValues) => {
  const result = {};
  Object.entries(fieldValues).forEach(([field, value]) => {
    const fieldKey = field;
    const associatedControl = controls.find((control) => control.name === field);
    if (associatedControl) {
      if (Array.isArray(value)) {
        const itemDefaultValues = defaultValues[fieldKey];
        if ("children" in associatedControl && Array.isArray(itemDefaultValues) && itemDefaultValues.length > 0) {
          result[fieldKey] = value.map(
            (item) => preFormat(item, associatedControl.children, itemDefaultValues[0])
          );
          return;
        }
      } else {
        if ("definition" in associatedControl) {
          const control = associatedControl.definition;
          if (control && !("component" in control) && control.type === "number" && typeof defaultValues[fieldKey] === "number") {
            const numberValue = NumberField2.getNumberValue(value);
            if (isNumber(numberValue)) {
              result[fieldKey] = numberValue;
            }
            return;
          }
        }
      }
    }
    result[fieldKey] = value;
  });
  return result;
};
var BuiltInControl = ({
  config,
  ...props
}) => {
  switch (config.type) {
    case "checkbox":
      return /* @__PURE__ */ React32.createElement(Form2.CheckboxField, { ...props, ...config.config });
    case "date":
      return /* @__PURE__ */ React32.createElement(Form2.DayField, { ...props, ...config.config });
    case "daterange":
      return /* @__PURE__ */ React32.createElement(Form2.DateRangeField, { ...props, ...config.config });
    case "filelist":
      return /* @__PURE__ */ React32.createElement(Form2.FileListField, { ...props, ...config.config });
    case "number":
      return /* @__PURE__ */ React32.createElement(Form2.NumberField, { ...props, ...config.config });
    case "password":
      return /* @__PURE__ */ React32.createElement(Form2.PasswordField, { ...props, ...config.config });
    case "phone":
      return /* @__PURE__ */ React32.createElement(Form2.PhoneField, { ...props, ...config.config });
    case "resource-checkbox":
      return /* @__PURE__ */ React32.createElement(Form2.ResourceCheckboxField, { ...props, ...config.config });
    case "select":
      return /* @__PURE__ */ React32.createElement(Form2.SelectField, { ...props, ...config.config });
    case "switch":
      return /* @__PURE__ */ React32.createElement(Form2.SwitchField, { ...props, ...config.config });
    case "text":
      return /* @__PURE__ */ React32.createElement(Form2.TextField, { ...props, ...config.config });
    default:
      return null;
  }
};
var CustomControl = ({
  name,
  definition,
  disabled,
  defaultValue,
  defaultValues
}) => {
  const controller = useController2({
    name,
    rules: {
      required: definition.required
    },
    defaultValue
  });
  return /* @__PURE__ */ React32.createElement(
    definition.component,
    {
      value: controller.field.value,
      setValue: controller.field.onChange,
      error: controller.fieldState.error,
      required: definition.required,
      disabled,
      useWatch: (options) => {
        const defaultValue2 = React32.useMemo(
          () => function findDefaultValue(nameParts, currentDefaults) {
            if (nameParts.length === 0) {
              return void 0;
            }
            const value = currentDefaults[nameParts[0]];
            if (value) {
              if (nameParts.length === 1) {
                return value;
              }
              return findDefaultValue(nameParts.slice(1), value);
            }
          }(options.name.split("."), defaultValues || {}),
          [options.name]
        );
        return useWatch({
          name: options.name,
          defaultValue: defaultValue2
        });
      }
    }
  );
};
var FormListField = (props) => {
  const { fields, append, remove } = useFieldArray({
    ...props.validation,
    name: props.name
  });
  const t = useInternalTranslate();
  return /* @__PURE__ */ React32.createElement("div", null, /* @__PURE__ */ React32.createElement("fieldset", null, /* @__PURE__ */ React32.createElement("div", { className: "flex justify-between items-center" }, /* @__PURE__ */ React32.createElement("legend", { className: "text-lg" }, props.label), fields.length !== 0 && /* @__PURE__ */ React32.createElement(Button2, { onClick: () => append(props.defaultValue), disabled: props.disabled, size: "sm" }, t("actions.add", { fallback: "Add" }))), fields.length === 0 ? /* @__PURE__ */ React32.createElement("div", { className: "p-6 text-center" }, /* @__PURE__ */ React32.createElement(Button2, { onClick: () => append(props.defaultValue), disabled: props.disabled }, t("actions.add", { fallback: "Add" }))) : /* @__PURE__ */ React32.createElement("table", { className: "w-full" }, /* @__PURE__ */ React32.createElement("thead", null, /* @__PURE__ */ React32.createElement("tr", null, props.items.map((item) => /* @__PURE__ */ React32.createElement("th", { className: "text-sm text-left font-medium uppercase", key: item.name }, "children" in item ? null : item.label)), /* @__PURE__ */ React32.createElement("th", null))), /* @__PURE__ */ React32.createElement("tbody", null, fields.map((field, index) => /* @__PURE__ */ React32.createElement("tr", { key: field.id }, /* @__PURE__ */ React32.createElement(
    ArrayFieldContext.Provider,
    {
      value: {
        name: props.name,
        index
      }
    },
    props.items.map((item) => /* @__PURE__ */ React32.createElement("td", { key: item.name }, "children" in item ? null : "component" in item.definition ? /* @__PURE__ */ React32.createElement(
      CustomControl,
      {
        name: item.name,
        definition: item.definition,
        disabled: props.disabled,
        key: item.name
      }
    ) : /* @__PURE__ */ React32.createElement(
      BuiltInControl,
      {
        name: item.name,
        config: item.definition,
        defaultValue: item.defaultValue,
        disabled: props.disabled,
        key: item.name
      }
    ))),
    /* @__PURE__ */ React32.createElement("td", { className: "text-right" }, /* @__PURE__ */ React32.createElement(
      "button",
      {
        onClick: () => remove(index),
        type: "button",
        disabled: props.disabled,
        "aria-label": "Remove"
      },
      /* @__PURE__ */ React32.createElement(HiX, { width: 20, height: 20, className: "w-5 h-5 text-gray-500" })
    ))
  )))))));
};

// src/components/resource-card-section-edit-button.tsx
var ResourceCardSectionEditButton = (props) => {
  const mergedDefaultValues = React33.useMemo(() => {
    const result = props.currentValues ? JSON.parse(JSON.stringify(props.currentValues)) : {};
    if (props.defaultValues) {
      (function mergeIntoResult(target, source) {
        Object.entries(source).forEach(([prop, value]) => {
          if (isNil2(target[prop])) {
            target[prop] = value;
          } else if (Array.isArray(value)) {
            const targetValue = target[prop];
            if (value.length === 1 && Array.isArray(targetValue) && targetValue.length === 1) {
              mergeIntoResult(targetValue[0], value[0]);
            }
          } else if (isObject3(value)) {
            if (isObject3(target[prop])) {
              mergeIntoResult(target[prop], value);
            }
          }
        });
      })(result, props.defaultValues);
    }
    return result;
  }, [props.currentValues, props.defaultValues]);
  const [isShowEditForm, setIsShowEditForm] = React33.useState(false);
  const t = useInternalTranslate();
  return /* @__PURE__ */ React33.createElement(Dialog2.Root, { open: isShowEditForm, onOpenChange: setIsShowEditForm }, /* @__PURE__ */ React33.createElement(Dialog2.Trigger, { asChild: true }, /* @__PURE__ */ React33.createElement(Button3, { size: "sm", icon: /* @__PURE__ */ React33.createElement(HiPencil, null), disabled: props.isLoading }, t("buttons.edit", { fallback: "Edit", ns: "common" }))), /* @__PURE__ */ React33.createElement(Dialog2.Portal, null, /* @__PURE__ */ React33.createElement(Dialog2.Overlay, null), /* @__PURE__ */ React33.createElement(Dialog2.Content, null, /* @__PURE__ */ React33.createElement(Dialog2.Title, null, t("actions.editSection", {
    fallback: `Edit ${props.sectionTitle}`,
    data: {
      section: props.sectionTitle
    }
  })), /* @__PURE__ */ React33.createElement(
    ResourceCardSectionEditForm,
    {
      ...props,
      defaultValues: mergedDefaultValues,
      onDismiss: () => setIsShowEditForm(false)
    }
  ))));
};
var ResourceCardSectionEditForm = (props) => {
  const t = useInternalTranslate();
  const form = useForm2({
    refineCoreProps: {
      resource: props.resourceName,
      id: props.resourceId,
      action: "edit",
      metaData: {
        fields: props.fields
      },
      redirect: false,
      onMutationSuccess: props.onDismiss,
      successNotification: {
        key: `update-${props.resourceName}-${props.resourceId}-${props.sectionTitle}`,
        type: "success",
        message: t("messages.sectionUpdateSuccess", {
          fallback: `${props.sectionTitle} updated successfully`,
          data: { section: props.sectionTitle }
        })
      },
      errorNotification: false
    }
  });
  const formId = `edit-${props.resourceName}-section-form`;
  return /* @__PURE__ */ React33.createElement("div", { className: "lg:min-w-[60rem]" }, /* @__PURE__ */ React33.createElement("div", { className: "py-3" }, /* @__PURE__ */ React33.createElement(
    DynamicForm,
    {
      form,
      defaultValues: props.defaultValues,
      controls: props.controls,
      submitText: false,
      id: formId,
      inferSections: false
    }
  )), /* @__PURE__ */ React33.createElement("div", { className: "flex flex-row-reverse gap-3 pt-2 border-t" }, /* @__PURE__ */ React33.createElement(
    Button3,
    {
      type: "submit",
      variant: "solid",
      loading: form.refineCore.mutationResult.isLoading,
      disabled: form.refineCore.formLoading,
      form: formId
    },
    t("buttons.save", { fallback: "Save", ns: "common" })
  ), /* @__PURE__ */ React33.createElement(
    Button3,
    {
      onClick: props.onDismiss,
      disabled: form.refineCore.formLoading || form.refineCore.mutationResult.isLoading
    },
    t("buttons.cancel", { fallback: "Cancel", ns: "common" })
  )));
};

// src/components/resource-card-section.tsx
var ResourceCardSection = (props) => {
  const { queryResult } = useShow2({
    resource: props.resourceName,
    id: props.resourceId,
    metaData: {
      fields: props.fields
    }
  });
  const t = useInternalTranslate();
  const renderField = (fieldName, fieldPrefixes, getValue, fallback) => {
    const fieldDisplayConfig = isFunction3(props.displays) ? props.displays({ t }) : props.displays;
    const fieldDisplay = fieldDisplayConfig && fieldDisplayConfig[[...fieldPrefixes, fieldName].join(".")];
    const data = queryResult.data?.data;
    if (isObject4(fieldDisplay)) {
      return /* @__PURE__ */ React34.createElement(
        DescList.Item,
        {
          label: fieldDisplay.label,
          value: data && (() => {
            if ("render" in fieldDisplay) {
              return fieldDisplay.render(data);
            }
            if ("type" in fieldDisplay) {
              const value = getValue();
              switch (fieldDisplay.type) {
                case "date":
                  return value && formatDate(value, { formatType: fieldDisplay.formatType });
                case "imageList":
                  {
                    if (Array.isArray(value)) {
                      if (value.length === 0) {
                        return "-";
                      }
                      return /* @__PURE__ */ React34.createElement("div", { className: "flex items-center gap-3 flex-wrap" }, value.map((item, index) => /* @__PURE__ */ React34.createElement("div", { key: index }, /* @__PURE__ */ React34.createElement(
                        "img",
                        {
                          src: item.url,
                          alt: item.alt || "",
                          className: "max-w-full md:max-w-md",
                          loading: "lazy"
                        }
                      ), fieldDisplay.showInfo && /* @__PURE__ */ React34.createElement("div", null, item.alt && /* @__PURE__ */ React34.createElement("div", { className: "text-sm" }, item.alt), item.createdAt && /* @__PURE__ */ React34.createElement("div", null, t("messages.uploadedAt", {
                        fallback: `Uploaded at ${formatDate(item.createdAt, {
                          formatType: "dateAndTime"
                        })}`,
                        data: {
                          time: formatDate(item.createdAt, {
                            formatType: "dateAndTime"
                          })
                        }
                      }))))));
                    }
                  }
                  break;
                case "text":
                  return value;
                default:
                  break;
              }
            }
          })(),
          span: fieldDisplay.span,
          key: fieldName
        }
      );
    }
    return fallback();
  };
  const createMakeField = (fieldPrefixes) => function mapField(field, index) {
    const getValueAtPaths = (paths) => {
      const resourceData = queryResult.data?.data;
      if (!resourceData) {
        return "";
      }
      let currentValue = resourceData;
      paths.forEach((prefix) => {
        currentValue = currentValue && currentValue[prefix];
      });
      return currentValue;
    };
    const renderStringField = (stringFieldName) => renderField(
      stringFieldName,
      fieldPrefixes,
      () => getValueAtPaths([...fieldPrefixes, stringFieldName]),
      () => /* @__PURE__ */ React34.createElement(
        DescList.Item,
        {
          label: inferLabelFromName(stringFieldName),
          value: (() => {
            const value = getValueAtPaths([...fieldPrefixes, stringFieldName]);
            if (!value) {
              return;
            }
            if (Array.isArray(value)) {
              if (value.length === 0) {
                return "";
              }
              if (value?.every(isString3)) {
                return formatStringList(value);
              }
            }
            return value;
          })(),
          key: stringFieldName
        }
      )
    );
    if (isObject4(field)) {
      if ("operation" in field && isString3(field.operation) && field.fields.length === 0) {
        return renderStringField(field.operation);
      }
      return /* @__PURE__ */ React34.createElement(React34.Fragment, { key: index }, Object.entries(field).map(([fieldName, innerFields]) => {
        return renderField(
          fieldName,
          fieldPrefixes,
          () => getValueAtPaths([...fieldPrefixes, fieldName]),
          () => Array.isArray(innerFields) ? /* @__PURE__ */ React34.createElement(React34.Fragment, { key: fieldName }, innerFields.map(createMakeField(fieldPrefixes.concat(fieldName)))) : null
        );
      }));
    }
    return isString3(field) ? renderStringField(field) : null;
  };
  const controlOverrides = React34.useMemo(
    () => ({
      components: isFunction3(props.editControls) ? props.editControls({ t }) : props.editControls,
      componentConfigDefaults: props.componentConfigDefaults
    }),
    [props.editControls, props.componentConfigDefaults]
  );
  const title = isFunction3(props.title) ? props.title({ t }) : props.title;
  return /* @__PURE__ */ React34.createElement(Card2, null, /* @__PURE__ */ React34.createElement(
    Card2.Header,
    {
      extra: (props.editControls || props.defaultValues) && /* @__PURE__ */ React34.createElement(
        ResourceCardSectionEditButton,
        {
          sectionTitle: title,
          resourceId: props.resourceId,
          resourceName: props.resourceName,
          fields: props.fields,
          controls: controlOverrides,
          currentValues: queryResult.data?.data,
          defaultValues: props.defaultValues,
          isLoading: queryResult.isLoading
        }
      ),
      bordered: true
    },
    title
  ), /* @__PURE__ */ React34.createElement(Card2.Body, null, /* @__PURE__ */ React34.createElement(DescList, { isLoading: queryResult.isLoading }, props.fields.map(createMakeField([])))));
};

// src/components/resource-related-resource-section.tsx
import * as React42 from "react";

// src/components/resource-table.tsx
import * as React41 from "react";

// src/hooks/use-resource-table.ts
import {
  useDelete,
  useNavigation as useNavigation2,
  useTranslate as useTranslate4
} from "@refinedev/core";
import { useTable } from "@refinedev/react-table";
import { callAll as callAll2, isFunction as isFunction4, useDebounce } from "@scalingworks/react-admin-ui";
import * as React35 from "react";

// src/components/filter-controls.helpers.ts
import { flattenOptions, formatDateRange, isString as isString4 } from "@scalingworks/react-admin-ui";
var formatAppliedFilters = (providedFilterConfig, appliedFilters) => {
  if (!providedFilterConfig) {
    return [];
  }
  const filterConfig = providedFilterConfig;
  const filterHelpers = getFilterHelpers(appliedFilters);
  const result = [];
  Object.entries(filterConfig).forEach(([field, control]) => {
    if ("component" in control) {
      result.push({
        field,
        label: control.formatAppliedFilters(filterHelpers.getFieldFilters(field) || []),
        onDismiss: defaultOnDismiss
      });
    } else {
      switch (control.type) {
        case "text": {
          const value = filterHelpers.getSingleValue(field);
          if (value) {
            result.push({
              field,
              label: value,
              onDismiss: defaultOnDismiss
            });
          }
          break;
        }
        case "select": {
          const value = filterHelpers.getSingleValue(field);
          const selectedOption = value && control.config.options.find((opt) => opt.value === value);
          if (selectedOption) {
            result.push({
              field,
              label: selectedOption.label,
              onDismiss: defaultOnDismiss
            });
          }
          break;
        }
        case "daterange": {
          const filters = filterHelpers.getFieldFilters(field);
          if (filters) {
            const fromFilter = filters.find((f) => f.operator === "gte");
            const toFilter = filters.find((f) => f.operator === "lte");
            if (fromFilter && fromFilter.value) {
              const label = formatDateRange(
                {
                  from: new Date(fromFilter.value),
                  to: toFilter && toFilter.value ? new Date(toFilter.value) : void 0
                },
                true
              );
              result.push({
                field,
                label,
                onDismiss: defaultOnDismiss
              });
            }
          }
          break;
        }
        case "multiselect": {
          const filter = filterHelpers.getSingleLogicalFilter(field);
          if (filter && Array.isArray(filter.value) && filter.value.length) {
            const valueFilters = filter.value;
            const allOptions = flattenOptions(control.config.options);
            if (valueFilters.length === 1) {
              const value = valueFilters[0].value;
              const selectedOption = value ? allOptions.find((opt) => opt.value === value) : void 0;
              if (selectedOption) {
                result.push({
                  field,
                  label: selectedOption.label,
                  onDismiss: defaultOnDismiss
                });
              }
            } else {
              valueFilters.forEach((filterValue, index) => {
                const selectedOption = allOptions.find((opt) => opt.value === filterValue.value);
                if (selectedOption) {
                  result.push({
                    field,
                    label: selectedOption.label,
                    key: `${field}${isString4(filterValue.value) ? filterValue.value : index}`,
                    onDismiss: ({ setFilters }) => setFilters([
                      {
                        key: field,
                        operator: "or",
                        value: valueFilters.filter((filter2) => filter2 !== filterValue)
                      }
                    ])
                  });
                }
              });
            }
          }
          break;
        }
        default:
          break;
      }
    }
  });
  return result;
};
var defaultOnDismiss = ({ removeFieldFilters }) => removeFieldFilters();
var getFilterHelpers = (filters) => {
  const filterMap = /* @__PURE__ */ new Map();
  filters.forEach((filter) => {
    const fieldName = "field" in filter ? filter.field : filter.key;
    if (fieldName) {
      const currentFilters = filterMap.get(fieldName);
      if (currentFilters) {
        currentFilters.push(filter);
      } else {
        filterMap.set(fieldName, [filter]);
      }
    }
  });
  return {
    getSingleValue: (field) => {
      const filters2 = filterMap.get(field);
      return filters2 && filters2[0] && filters2[0].value;
    },
    getSingleLogicalFilter: (field) => {
      const filters2 = filterMap.get(field);
      if (!filters2) {
        return void 0;
      }
      const conditionalFilters = filters2.filter(
        (f) => f.operator === "or" || f.operator === "and"
      );
      return conditionalFilters[0];
    },
    getFieldFilters: (field) => {
      return filterMap.get(field);
    }
  };
};

// src/hooks/use-resource-update.ts
import { useUpdate } from "@refinedev/core";
var createResourceUpdate = (options) => () => {
  const { mutate, mutateAsync: _, ...rest } = useUpdate();
  return {
    ...rest,
    mutate: ({ changes, id }, { successMessage = "Successfully updated", ...mutationOptions } = {}) => mutate(
      {
        resource: options.resourceName,
        values: changes,
        id,
        successNotification: {
          key: `update-${options.resourceName}-${id}`,
          type: "success",
          message: successMessage
        }
      },
      mutationOptions
    )
  };
};

// src/lib/view-transition.ts
function transitionHelper({
  updateDOM,
  skipTransition = false,
  classNames = []
}) {
  if (skipTransition || !document.startViewTransition) {
    const domUpdated = Promise.resolve(updateDOM()).then(() => void 0);
    return {
      ready: Promise.reject(Error("View transitions unsupported")),
      domUpdated,
      finished: domUpdated
    };
  }
  document.documentElement.classList.add(...classNames);
  const transition = document.startViewTransition(updateDOM);
  transition.finished.finally(() => document.documentElement.classList.remove(...classNames));
  return transition;
}

// src/hooks/use-resource-table.ts
var useResourceTable = ({
  resource,
  columns,
  defaultPageSize = 10,
  defaultSorter = [{ field: "id", order: "asc" }],
  fields,
  refineCoreProps = {},
  allowSearch,
  searchConfig,
  filterConfig,
  filterControls,
  extraMeta,
  ...restProps
}) => {
  const navigateTo = useNavigation2();
  const t = useInternalTranslate();
  const [idToBeDelete, setIdToBeDelete] = React35.useState("");
  const [isSearching, setIsSearching] = React35.useState(false);
  const { mutate: invokeDelete } = useDelete();
  const { queryOptions = {} } = refineCoreProps;
  const { alwaysExpanded } = filterConfig || {};
  const refetchData = () => {
    if (table) {
      table.refineCore.tableQueryResult.refetch();
    }
  };
  const table = useTable({
    columns: React35.useMemo(
      () => columns({
        navigateToEdit: ({ id }) => transitionHelper({
          updateDOM: () => navigateTo.edit(resource, id)
        }),
        navigateToDetails: ({ id }) => transitionHelper({
          updateDOM: () => navigateTo.show(resource, id)
        }),
        navigateToResource: ({ id, resourceName }) => transitionHelper({
          updateDOM: () => navigateTo.show(resourceName, id)
        }),
        invokeDelete: ({ id }) => {
          setIdToBeDelete(id);
          invokeDelete(
            {
              id,
              resource
            },
            {
              onSettled: () => setIdToBeDelete("")
            }
          );
        },
        useUpdate: createResourceUpdate({
          resourceName: resource
        }),
        LinkToDetails: function({ resourceName = resource, ...props }) {
          return React35.createElement(LinkToDetails, {
            ...props,
            resourceName
          });
        },
        refetchData,
        t
      }).map((column) => ({
        enableSorting: false,
        ...column
      })),
      [columns]
    ),
    refineCoreProps: {
      ...refineCoreProps,
      queryOptions: {
        ...queryOptions,
        onSettled: callAll2(queryOptions.onSettled, () => setIsSearching(false))
      },
      metaData: {
        fields,
        ...extraMeta
      },
      resource,
      initialSorter: defaultSorter,
      initialPageSize: defaultPageSize,
      initialCurrent: 1
    },
    ...restProps
  });
  const { filters, setFilters } = table.refineCore;
  const filterValues = React35.useMemo(() => {
    const result = {};
    filters.forEach((filter) => {
      if ("field" in filter) {
        result[filter.field] = filter.value;
      } else {
        result[filter.key] = filter.value;
      }
    });
    return result;
  }, [filters]);
  const [searchText, setSearchText] = React35.useState(
    filterValues.search || ""
  );
  useDebounce(searchText, {
    onChange: allowSearch ? (appliedSearch) => {
      setFilters(
        [
          {
            field: "search",
            value: appliedSearch,
            operator: searchConfig?.operator || "eq"
          }
        ],
        "merge"
      );
      if (appliedSearch) {
        setIsSearching(true);
      }
    } : void 0
  });
  const hasFilter = !!filterControls && Object.keys(filterControls).length > 0;
  const [isFilterExpanded, toggleIsFilterExpanded] = React35.useReducer(
    (x) => !x,
    filterConfig?.alwaysExpanded ? true : false
  );
  const appliedFilters = React35.useMemo(
    () => formatAppliedFilters(filterControls, filters),
    [filters]
  );
  return {
    table,
    idToBeDelete,
    searchInputProps: {
      value: searchText,
      onValue: setSearchText,
      isLoading: isSearching,
      placeholder: isFunction4(searchConfig?.placeholder) ? searchConfig?.placeholder({ t: useTranslate4() }) : ""
    },
    filterRootProps: {
      open: isFilterExpanded,
      onOpenChange: !alwaysExpanded ? toggleIsFilterExpanded : () => null
    },
    filterTriggerProps: {
      isExpanded: isFilterExpanded,
      appliedFilters,
      hasFilter
    },
    filterContentProps: {
      filters,
      setFilters,
      config: filterControls
    },
    appliedFilterListProps: {
      filters,
      appliedFilters,
      setFilters
    },
    hasFilter,
    tableHasFilter: hasFilter || !!searchText,
    setFilters
  };
};

// src/components/applied-filter-list.tsx
import { clsx as clsx5 } from "clsx";
import * as React36 from "react";
import { HiOutlineX } from "react-icons/hi";
var AppliedFilterList = ({
  appliedFilters,
  setFilters,
  filters,
  ...props
}) => {
  const t = useInternalTranslate();
  const filterCount = appliedFilters.length;
  const getHelpers = React36.useCallback(
    (field) => {
      const helpers = getFilterHelpers(filters);
      return {
        getFieldFilters: () => helpers.getFieldFilters(field),
        getFieldLogicalFilter: () => helpers.getSingleLogicalFilter(field),
        setFilters,
        removeFieldFilters: () => setFilters(
          (prevFilters) => prevFilters.filter(
            (prevFilter) => "field" in prevFilter ? prevFilter.field !== field : "key" in prevFilter ? prevFilter.key !== field : true
          )
        )
      };
    },
    [filters, setFilters]
  );
  if (filterCount === 0) {
    return null;
  }
  return /* @__PURE__ */ React36.createElement("div", { ...props, className: clsx5("flex items-center gap-3 flex-wrap", props.className) }, /* @__PURE__ */ React36.createElement("span", { className: "inline-block text-sm text-gray-600" }, t("pages.list.appliedFilter", {
    fallback: `Applied ${filterCount === 1 ? "filter" : "filters:"}`,
    data: { count: filterCount }
  })), appliedFilters.map((filter) => /* @__PURE__ */ React36.createElement(
    "span",
    {
      key: filter.key || filter.field,
      className: "inline-flex justify-between items-center gap-1 min-w-[4rem] text-sm pl-2 pr-1.5 py-0.5 rounded-lg bg-gray-200 text-gray-800"
    },
    filter.label,
    /* @__PURE__ */ React36.createElement("button", { onClick: () => filter.onDismiss(getHelpers(filter.field)), type: "button" }, /* @__PURE__ */ React36.createElement(HiOutlineX, { width: 16, height: 16, className: "w-4 h-4 text-gray-500", "aria-hidden": true }))
  )));
};

// src/components/data-query-indicator.tsx
import { useNotification, useTranslate as useTranslate5 } from "@refinedev/core";
import { IconButton, Spinner as Spinner3, TextTooltip, formatDate as formatDate2 } from "@scalingworks/react-admin-ui";
import { clsx as clsx6 } from "clsx";
import * as React37 from "react";
import { HiOutlineExclamation, HiOutlineRefresh } from "react-icons/hi";
import { HiOutlineBellAlert, HiOutlineBellSlash } from "react-icons/hi2";
var DataQueryIndicator = ({
  queryResult,
  timeSensitive,
  isWatching,
  onIsWatchingChange
}) => {
  const { open } = useNotification();
  const t = useInternalTranslate();
  const translate = useTranslate5();
  return /* @__PURE__ */ React37.createElement("div", { className: "inline-flex items-center gap-2" }, queryResult.isError && /* @__PURE__ */ React37.createElement(
    TextTooltip,
    {
      text: t("messages.dataMaybeOutdated", {
        fallback: "Data may be outdated as we fail to get latest data"
      })
    },
    /* @__PURE__ */ React37.createElement("div", null, /* @__PURE__ */ React37.createElement(HiOutlineExclamation, { className: "w-5 h-5 text-gray-500", width: 20, height: 20 }))
  ), onIsWatchingChange && /* @__PURE__ */ React37.createElement(
    TextTooltip,
    {
      text: isWatching ? t("actions.stopNotification", { fallback: "Stop notification" }) : t("actions.getNotification", { fallback: "Keep me notified of change" })
    },
    /* @__PURE__ */ React37.createElement(IconButton, { onClick: () => onIsWatchingChange(!isWatching) }, isWatching ? /* @__PURE__ */ React37.createElement(HiOutlineBellAlert, { width: 20, height: 20, className: "w-5 h-5 text-primary-500" }) : /* @__PURE__ */ React37.createElement(HiOutlineBellSlash, { width: 20, height: 20, className: "w-5 h-5 text-gray-500" }))
  ), timeSensitive ? /* @__PURE__ */ React37.createElement(React37.Fragment, null, /* @__PURE__ */ React37.createElement(TextTooltip, { text: translate("buttons.refresh", "Refresh") }, /* @__PURE__ */ React37.createElement(
    IconButton,
    {
      onClick: () => queryResult.refetch().then(
        () => open && open({
          type: "success",
          message: t("messages.dataUpdateSuccess", {
            fallback: "Data updated succesfully"
          })
        })
      ),
      disabled: queryResult.isLoading || queryResult.isRefetching
    },
    /* @__PURE__ */ React37.createElement(
      HiOutlineRefresh,
      {
        width: 20,
        height: 20,
        className: clsx6(
          "w-5 h-5 text-gray-500 will-change-transform animate-spin [animation-direction:reverse]",
          queryResult.isRefetching ? "[animation-play-state:running]" : "[animation-play-state:paused]"
        )
      }
    )
  )), queryResult.dataUpdatedAt ? /* @__PURE__ */ React37.createElement("span", { className: "text-xs text-gray-500" }, t("pages.list.lastUpdatedAt", {
    fallback: `Last updated at ${formatDate2(new Date(queryResult.dataUpdatedAt), {
      format: "h:mm:ss a"
    })}`,
    data: {
      time: formatDate2(new Date(queryResult.dataUpdatedAt), { format: "h:mm:ss a" })
    }
  })) : null) : /* @__PURE__ */ React37.createElement(
    "div",
    {
      className: clsx6(
        "transition delay-100",
        queryResult.isRefetching ? "scale-100" : "scale-50"
      )
    },
    /* @__PURE__ */ React37.createElement(
      Spinner3,
      {
        size: 24,
        className: clsx6(
          "transition delay-100",
          queryResult.isRefetching ? "opacity-100" : "opacity-0"
        ),
        "aria-hidden": true
      }
    )
  ));
};

// src/components/data-table.tsx
import {
  Button as Button4,
  Checkbox,
  Pagination,
  Table
} from "@scalingworks/react-admin-ui";
import { flexRender } from "@tanstack/react-table";
import { clsx as clsx7 } from "clsx";
import * as React38 from "react";
import { HiOutlineSparkles } from "react-icons/hi";
var DataTable = ({
  tableConfig,
  idToBeDelete,
  hasFilter,
  highlightedIds,
  hidePagination,
  bulkConfig
}) => {
  const { tableQueryResult } = tableConfig.refineCore;
  const {
    allowBulkSelection: allowBulk = false,
    bulkActions = [],
    onBulkAction
  } = bulkConfig || {};
  const placeholder = function getPlaceholder() {
    if (tableQueryResult.isLoading) {
      const headerGroups = tableConfig.getLeafHeaders().map((group) => ({
        id: group.id,
        size: group.getSize()
      }));
      return Array.from({ length: 10 }).map((_, i) => /* @__PURE__ */ React38.createElement(Table.Tr, { key: i }, headerGroups.map((group) => /* @__PURE__ */ React38.createElement(Table.Td, { key: group.id }, /* @__PURE__ */ React38.createElement(
        "div",
        {
          className: clsx7(
            "h-5 bg-gray-200 animate-pulse",
            group.size > 100 ? "w-24" : "w-10"
          )
        }
      )))));
    }
    return null;
  }();
  const rowModel = tableConfig.getRowModel();
  const t = useInternalTranslate();
  const bulkPanel = () => {
    const selectedCount = tableConfig.getSelectedRowModel()?.rows?.length || 0;
    if (allowBulk && selectedCount) {
      return /* @__PURE__ */ React38.createElement("div", { className: "flex flex-row flex-wrap w-full justify-start items-center -mt-2 pb-4 px-4 space-x-3 space-x-1" }, /* @__PURE__ */ React38.createElement(
        Button4,
        {
          variant: "default",
          size: "sm",
          className: "my-2 lg:my-0",
          onClick: () => tableConfig.resetRowSelection()
        },
        `${t("actions.clearSelection", {
          fallback: scalingworks_default.actions.clearSelection
        })} (${selectedCount})`
      ), bulkActions.map((action) => /* @__PURE__ */ React38.createElement(
        Button4,
        {
          variant: "solid",
          size: "sm",
          className: `my-2 lg:my-0`,
          ...action.buttonProps,
          onClick: () => onBulkAction?.(action.key, tableConfig.getSelectedRowModel()?.rows?.map((row) => row.original))
        },
        action.label
      )));
    }
    return null;
  };
  return /* @__PURE__ */ React38.createElement(React38.Fragment, null, bulkPanel(), /* @__PURE__ */ React38.createElement(Table, null, /* @__PURE__ */ React38.createElement(Table.Thead, null, tableConfig.getHeaderGroups().map((group) => /* @__PURE__ */ React38.createElement(Table.Tr, { key: group.id }, allowBulk && /* @__PURE__ */ React38.createElement(Table.Th, null, /* @__PURE__ */ React38.createElement(
    Checkbox,
    {
      className: "-ml-2",
      checked: tableConfig.getIsAllRowsSelected(),
      onCheckedChange: (checked) => {
        tableConfig.toggleAllRowsSelected(checked);
      }
    }
  )), group.headers.map((header) => {
    const canSort = header.column.getCanSort();
    const content = header.isPlaceholder ? null : flexRender(
      header.column.columnDef.header,
      header.getContext()
    );
    return /* @__PURE__ */ React38.createElement(Table.Th, { key: header.id }, canSort ? /* @__PURE__ */ React38.createElement("span", { className: "flex justify-between" }, content, /* @__PURE__ */ React38.createElement(
      "button",
      {
        type: "button",
        onClick: header.column.getToggleSortingHandler()
      },
      /* @__PURE__ */ React38.createElement(Table.Sorter, { sort: header.column.getIsSorted() })
    )) : content);
  })))), /* @__PURE__ */ React38.createElement(Table.Tbody, null, /* @__PURE__ */ React38.createElement(React38.Fragment, null, placeholder, rowModel.rows.map((row) => {
    const rowId = row.original.id;
    return /* @__PURE__ */ React38.createElement(
      Table.Tr,
      {
        key: row.id,
        className: clsx7(
          rowId === idToBeDelete && "animate-pulse pointer-events-none",
          highlightedIds && rowId && highlightedIds.has(rowId) && "bg-primary-100"
        )
      },
      allowBulk && /* @__PURE__ */ React38.createElement(Table.Td, { className: "w-1" }, /* @__PURE__ */ React38.createElement(
        Checkbox,
        {
          className: "-ml-2",
          checked: row.getIsSelected(),
          onCheckedChange: (checked) => {
            tableConfig.setRowSelection((current) => ({
              ...current,
              [row.id]: checked
            }));
          }
        }
      )),
      row.getVisibleCells().map((cell) => /* @__PURE__ */ React38.createElement(Table.Td, { key: cell.id }, flexRender(
        cell.column.columnDef.cell,
        cell.getContext()
      )))
    );
  }))), !tableQueryResult.isLoading && rowModel.rows.length === 0 && /* @__PURE__ */ React38.createElement("tfoot", null, /* @__PURE__ */ React38.createElement("tr", null, /* @__PURE__ */ React38.createElement("td", { colSpan: tableConfig.getAllFlatColumns().length }, /* @__PURE__ */ React38.createElement("span", { className: "w-full flex flex-col gap-3 justify-center items-center p-6" }, /* @__PURE__ */ React38.createElement(
    HiOutlineSparkles,
    {
      className: "w-9 h-9 text-gray-300",
      width: 36,
      height: 36
    }
  ), /* @__PURE__ */ React38.createElement("span", { className: "text-gray-600" }, hasFilter ? t("messages.noDataWithFilter", {
    fallback: scalingworks_default.messages.noDataWithFilter
  }) : t("messages.noData", {
    fallback: scalingworks_default.messages.noData
  }))))))), hidePagination ? null : /* @__PURE__ */ React38.createElement(
    Pagination,
    {
      totalPages: tableConfig.refineCore.pageCount,
      currentPage: tableConfig.refineCore.current,
      onChangePage: tableConfig.refineCore.setCurrent,
      perPage: tableConfig.refineCore.pageSize,
      onChangePerPage: tableConfig.refineCore.setPageSize,
      className: "mt-3",
      formatOption: (numOfPage) => t("pages.list.pageSize", {
        data: { numOfPage },
        fallback: `${numOfPage} / page`
      }),
      previousPageAriaLabel: t("pages.list.prevPage", {
        fallback: scalingworks_default.pages.list.prevPage
      }),
      nextPageAriaLabel: t("pages.list.nextPage", {
        fallback: scalingworks_default.pages.list.nextPage
      })
    }
  ));
};

// src/components/filter-controls-collapsible.tsx
import { useTranslate as useTranslate6 } from "@refinedev/core";
import { Badge, Button as Button5, Collapsible } from "@scalingworks/react-admin-ui";
import * as React40 from "react";
import { HiOutlineFilter } from "react-icons/hi";

// src/components/filter-controls.tsx
import {
  DateRangeField as DateRangeField2,
  MultiSelectField,
  SelectField as SelectField2,
  TextField as TextField4,
  formatDateUtc as formatDateUtc2,
  useDebounce as useDebounce2
} from "@scalingworks/react-admin-ui";
import * as React39 from "react";
var FilterControls = (props) => {
  const config = props.config ?? {};
  const removeFilter = React39.useCallback(
    (field) => {
      props.setFilters(
        (prevFilters) => prevFilters.filter(
          (prevFilter) => "field" in prevFilter ? prevFilter.field !== field : "key" in prevFilter ? prevFilter.key !== field : true
        )
      );
    },
    [props.setFilters]
  );
  const filterHelpers = React39.useMemo(() => getFilterHelpers(props.filters), [props.filters]);
  const controls = Object.entries(config).map(([key, controlConfig]) => {
    const field = key;
    const singleValue = filterHelpers.getSingleValue(field);
    if ("component" in controlConfig) {
      return /* @__PURE__ */ React39.createElement(
        controlConfig.component,
        {
          filters: filterHelpers.getFieldFilters(field),
          setFilters: props.setFilters,
          key
        }
      );
    }
    switch (controlConfig.type) {
      case "text":
        return /* @__PURE__ */ React39.createElement(
          DebouncedTextField,
          {
            layout: "vertical",
            size: "sm",
            ...controlConfig.config,
            value: singleValue || "",
            onValue: (value) => value ? props.setFilters([
              {
                field,
                value,
                operator: controlConfig.operator
              }
            ]) : removeFilter(field),
            key
          }
        );
      case "select":
        return /* @__PURE__ */ React39.createElement(
          SelectField2,
          {
            layout: "vertical",
            size: "sm",
            ...controlConfig.config,
            value: singleValue || "",
            onValue: (value) => value ? props.setFilters([
              {
                field,
                value,
                operator: controlConfig.operator
              }
            ]) : removeFilter(field),
            key
          }
        );
      case "multiselect":
        return /* @__PURE__ */ React39.createElement(
          MultiSelectFilterField,
          {
            ...controlConfig.config,
            filter: filterHelpers.getSingleLogicalFilter(field),
            setFilters: props.setFilters,
            fieldName: field,
            removeFilter: () => removeFilter(field),
            key
          }
        );
      case "daterange":
        return /* @__PURE__ */ React39.createElement(
          DateRangeFilterField,
          {
            ...controlConfig.config,
            filters: filterHelpers.getFieldFilters(field),
            setFilters: props.setFilters,
            removeFilter: () => removeFilter(field),
            fieldName: field,
            key
          }
        );
      default:
        return null;
    }
  });
  return /* @__PURE__ */ React39.createElement(
    "div",
    {
      style: {
        gridTemplateColumns: `repeat(auto-fill, minmax(220px, 1fr))`
      },
      className: "grid gap-5"
    },
    controls
  );
};
var DateRangeFilterField = ({
  filters,
  setFilters,
  removeFilter,
  fieldName,
  ...props
}) => {
  const computedValue = React39.useMemo(() => {
    if (!filters || filters.length === 0) {
      return void 0;
    }
    const fromFilter = filters.find((filter) => filter.operator === "gte");
    const toFilter = filters.find((filter) => filter.operator === "lte");
    return {
      from: fromFilter && fromFilter.value ? new Date(fromFilter.value) : void 0,
      to: toFilter && toFilter.value ? new Date(toFilter.value) : void 0
    };
  }, [filters]);
  const handleValue = React39.useCallback(
    (dateRange) => {
      if (!dateRange || !dateRange.from) {
        return removeFilter();
      }
      const filters2 = [];
      if (dateRange.from) {
        filters2.push({
          field: fieldName,
          value: formatDateUtc2(dateRange.from),
          operator: "gte"
        });
      }
      if (dateRange.to) {
        filters2.push({
          field: fieldName,
          value: formatDateUtc2(dateRange.to),
          operator: "lte"
        });
      }
      setFilters(filters2);
    },
    [setFilters, removeFilter]
  );
  return /* @__PURE__ */ React39.createElement("div", { className: "sm:col-span-2" }, /* @__PURE__ */ React39.createElement(
    DateRangeField2,
    {
      layout: "vertical",
      size: "sm",
      ...props,
      value: computedValue,
      onValue: handleValue
    }
  ));
};
var MultiSelectFilterField = ({
  filter,
  setFilters,
  removeFilter,
  fieldName,
  ...props
}) => {
  const computedValue = React39.useMemo(() => {
    if (!filter) {
      return [];
    }
    return Array.isArray(filter.value) ? filter.value.map((v) => v.value) : [];
  }, [filter]);
  const handleValue = React39.useCallback(
    (values) => {
      if (!values.length) {
        return removeFilter();
      }
      setFilters([
        {
          key: fieldName,
          operator: "or",
          value: values.map((value) => ({
            field: fieldName,
            value,
            operator: "eq"
          }))
        }
      ]);
    },
    [setFilters, removeFilter]
  );
  return /* @__PURE__ */ React39.createElement(
    MultiSelectField,
    {
      layout: "vertical",
      size: "sm",
      ...props,
      value: computedValue,
      onValue: handleValue
    }
  );
};
var DebouncedTextField = (props) => {
  const [value, setValue] = React39.useState(props.value);
  React39.useEffect(() => {
    if (props.value !== value) {
      setValue(props.value);
    }
  }, [props.value]);
  useDebounce2(value, {
    onChange: (newVal) => props.onValue(newVal.trim())
  });
  return /* @__PURE__ */ React39.createElement(TextField4, { ...props, value, onValue: setValue });
};

// src/components/filter-controls-collapsible.tsx
var FilterControlsCollapsible = {
  Root: function CollapsibleRoot(props) {
    return /* @__PURE__ */ React40.createElement(Collapsible.Root, { ...props });
  },
  Trigger: function FilterTrigger(props) {
    const translate = useTranslate6();
    return props.hasFilter ? /* @__PURE__ */ React40.createElement("div", { className: "relative" }, !props.isExpanded && props.appliedFilters.length > 0 && /* @__PURE__ */ React40.createElement(Badge, null, props.appliedFilters.length), /* @__PURE__ */ React40.createElement(Collapsible.Trigger, { asChild: true }, /* @__PURE__ */ React40.createElement(
      Button5,
      {
        variant: props.isExpanded ? "solid" : "default",
        size: "sm",
        icon: /* @__PURE__ */ React40.createElement(HiOutlineFilter, null),
        className: "min-w-[7rem]"
      },
      translate("buttons.filter", "Filter")
    ))) : null;
  },
  Content: function FilterContent({
    className,
    ...props
  }) {
    return /* @__PURE__ */ React40.createElement(Collapsible.Content, { className }, /* @__PURE__ */ React40.createElement(FilterControls, { ...props }));
  }
};

// src/components/resource-table.tsx
var ResourceTable = ({
  config
}) => {
  const {
    table,
    idToBeDelete,
    tableHasFilter,
    searchInputProps,
    filterRootProps,
    filterTriggerProps,
    hasFilter,
    filterContentProps,
    appliedFilterListProps
  } = useResourceTable({
    resource: config.resource,
    columns: config.columns,
    fields: config.fields,
    allowSearch: config.allowSearch,
    filterControls: config.filterControls,
    defaultSorter: config.defaultSorter,
    refineCoreProps: {
      initialFilter: config.initialFilters
    }
  });
  return /* @__PURE__ */ React41.createElement("div", { className: "flex flex-col gap-3" }, config.allowSearch || hasFilter ? /* @__PURE__ */ React41.createElement(FilterControlsCollapsible.Root, { ...filterRootProps, className: "flex flex-col gap-3" }, /* @__PURE__ */ React41.createElement("div", { className: "flex justify-between items-center" }, /* @__PURE__ */ React41.createElement(DataQueryIndicator, { queryResult: table.refineCore.tableQueryResult }), /* @__PURE__ */ React41.createElement("div", { className: "flex gap-2" }, config.allowSearch && /* @__PURE__ */ React41.createElement(SearchInput, { ...searchInputProps }), /* @__PURE__ */ React41.createElement(FilterControlsCollapsible.Trigger, { ...filterTriggerProps }))), hasFilter && /* @__PURE__ */ React41.createElement(FilterControlsCollapsible.Content, { ...filterContentProps })) : null, hasFilter && /* @__PURE__ */ React41.createElement(AppliedFilterList, { ...appliedFilterListProps }), /* @__PURE__ */ React41.createElement(
    DataTable,
    {
      tableConfig: table,
      idToBeDelete,
      hasFilter: tableHasFilter,
      hidePagination: config.hidePagination
    }
  ));
};

// src/components/resource-related-resource-section.tsx
var ResourceRelatedResourceSection = ({
  resourceName,
  resourceId,
  relatedResourceName,
  getInitialFilter: getInitialFilter2,
  ...props
}) => {
  return /* @__PURE__ */ React42.createElement(
    ResourceTable,
    {
      config: {
        ...props,
        resource: relatedResourceName,
        initialFilters: getInitialFilter2({
          id: resourceId,
          resourceName
        })
      }
    }
  );
};

// src/components/resource-stats-section.tsx
import { useShow as useShow3, useTranslate as useTranslate7, useUpdate as useUpdate2 } from "@refinedev/core";
import {
  Button as Button6,
  Dialog as Dialog3,
  FileItem as FileItem2,
  FileUpload as FileUpload2,
  IconButton as IconButton2,
  Skeleton as Skeleton3,
  StatsCard
} from "@scalingworks/react-admin-ui";
import * as React43 from "react";
import { BiImageAdd } from "react-icons/bi";
import { HiOutlinePencil, HiOutlinePhotograph } from "react-icons/hi";
var ResourceStatsSection = (props) => {
  const { queryResult } = useShow3({
    resource: props.resourceName,
    id: props.resourceId,
    metaData: {
      fields: props.fields
    }
  });
  const resourceData = queryResult.data?.data;
  const { isLoading } = queryResult;
  const imageUrl = props.imageField && resourceData && resourceData[props.imageField];
  const [showImageDialog, setShowImageDialog] = React43.useState(false);
  const { mutate: updateImage, isLoading: isUpdatingImage } = useUpdate2();
  const t = useInternalTranslate();
  return /* @__PURE__ */ React43.createElement("div", { className: "flex flex-col md:flex-row md:items-center gap-3 lg:gap-10" }, props.imageField ? /* @__PURE__ */ React43.createElement(Dialog3.Root, { open: showImageDialog, onOpenChange: setShowImageDialog }, /* @__PURE__ */ React43.createElement("div", { className: "block flex-shrink-0" }, isLoading ? /* @__PURE__ */ React43.createElement(Skeleton3, { widthClass: "w-36", heightClass: "h-36", className: "animate-pulse rounded-md" }) : imageUrl ? /* @__PURE__ */ React43.createElement("div", { className: "relative w-36 h-36 shadow rounded-md group/image" }, /* @__PURE__ */ React43.createElement("img", { src: imageUrl, className: "w-36 h-36 object-contain", width: 144, height: 144 }), props.allowChangeImage && /* @__PURE__ */ React43.createElement(Dialog3.Trigger, { asChild: true }, /* @__PURE__ */ React43.createElement(IconButton2, { className: "absolute top-1 right-1 opacity-0 focus:opacity-100 bg-white group-hover/image:opacity-100 transition" }, /* @__PURE__ */ React43.createElement(HiOutlinePencil, { width: 20, height: 20, className: "w-5 h-5 text-gray-500" })))) : props.allowChangeImage ? /* @__PURE__ */ React43.createElement(Dialog3.Trigger, { className: "flex justify-center items-center w-36 h-36 rounded-md shadow hover:bg-gray-50" }, /* @__PURE__ */ React43.createElement(BiImageAdd, { width: 32, height: 32, className: "w-8 h-8 text-gray-500" })) : /* @__PURE__ */ React43.createElement("div", { className: "flex justify-center items-center w-36 h-36 rounded-md shadow" }, /* @__PURE__ */ React43.createElement(HiOutlinePhotograph, { width: 32, height: 32, className: "w-8 h-8 text-gray-500" }))), props.allowChangeImage && /* @__PURE__ */ React43.createElement(Dialog3.Portal, null, /* @__PURE__ */ React43.createElement(Dialog3.Overlay, null), /* @__PURE__ */ React43.createElement(Dialog3.Content, null, /* @__PURE__ */ React43.createElement(Dialog3.Title, null, t("pages.show.image", { fallback: "Image" })), /* @__PURE__ */ React43.createElement(
    AddImageForm,
    {
      onSave: (imageUrl2) => updateImage(
        {
          resource: props.resourceName,
          id: props.resourceId,
          values: {
            [props.imageField]: imageUrl2
          }
        },
        {
          onSuccess: () => setShowImageDialog(false)
        }
      ),
      isSaving: isUpdatingImage
    }
  ), /* @__PURE__ */ React43.createElement(Dialog3.CloseButton, null)))) : null, /* @__PURE__ */ React43.createElement("div", { className: "md:flex-1 max-w-lg" }, /* @__PURE__ */ React43.createElement(
    StatsCard,
    {
      isLoading,
      items: props.stats.map((stat) => ({
        label: stat.label,
        value: resourceData && stat.value(resourceData)
      }))
    }
  )));
};
var AddImageForm = (props) => {
  const { items, addFile, results } = useFileUploads({
    uploadOperation: "instant",
    purpose: "image",
    maxCount: 1
  });
  const translate = useTranslate7();
  return /* @__PURE__ */ React43.createElement("div", { className: "pt-2" }, items.length === 0 ? /* @__PURE__ */ React43.createElement(
    FileUpload2,
    {
      fileType: "image",
      Icon: HiOutlinePhotograph,
      onFilesSelected: (files) => files[0] && addFile(files[0])
    }
  ) : items.map((item) => /* @__PURE__ */ React43.createElement(FileItem2, { ...item })), /* @__PURE__ */ React43.createElement("div", { className: "py-1 text-right" }, /* @__PURE__ */ React43.createElement(
    Button6,
    {
      onClick: () => props.onSave(results[0].url),
      variant: "solid",
      disabled: results.length === 0,
      loading: props.isSaving
    },
    translate("buttons.save", "Save")
  )));
};

// src/components/resource-tabs-section.tsx
import { Tabs } from "@scalingworks/react-admin-ui";
import { paramCase } from "change-case";
import * as React44 from "react";
var ResourceTabsSection = (props) => {
  const normalizedTab = React44.useMemo(
    () => props.tabs.map((tab) => ({
      ...tab,
      value: paramCase(tab.label)
    })),
    [props.tabs]
  );
  return normalizedTab.length > 0 ? /* @__PURE__ */ React44.createElement(Tabs.Root, { defaultValue: normalizedTab[0].value }, /* @__PURE__ */ React44.createElement(Tabs.List, null, normalizedTab.map((tab) => /* @__PURE__ */ React44.createElement(Tabs.Trigger, { value: tab.value, key: tab.label }, tab.label))), normalizedTab.map((tab) => /* @__PURE__ */ React44.createElement(
    Tabs.Content,
    {
      value: tab.value,
      className: "flex flex-col gap-5 py-2 data-[state=inactive]:hidden",
      key: tab.label
    },
    tab.content.map(
      (section, contentIndex) => section.type === "card" ? /* @__PURE__ */ React44.createElement(
        ResourceCardSection,
        {
          resourceName: props.resourceName,
          resourceId: props.resourceId,
          ...section,
          key: contentIndex
        }
      ) : section.type === "stats" ? /* @__PURE__ */ React44.createElement(
        ResourceStatsSection,
        {
          ...section,
          resourceName: props.resourceName,
          resourceId: props.resourceId,
          key: contentIndex
        }
      ) : section.type === "related" ? /* @__PURE__ */ React44.createElement(
        ResourceRelatedResourceSection,
        {
          ...section,
          resourceName: props.resourceName,
          resourceId: props.resourceId,
          key: contentIndex
        }
      ) : null
    )
  ))) : null;
};

// src/components/create-default-show-page.tsx
import { HiArrowLeft } from "react-icons/hi";
var createDefaultShowPage = (options) => {
  const { resourceName, sections } = options;
  const DefaultShowPage = ({
    queryResult,
    title,
    resourceId,
    allowDelete,
    allowEdit,
    resourceLabel
  }) => {
    const navigateTo = useNavigation3();
    const translate = useTranslate8();
    const getResourceLabel = useGetResourceLabel(options.resourceName);
    const deleteOperation = useDelete2();
    const [showDeleteConfirmation, setShowDeleteConfirmation] = React45.useState(false);
    const t = useInternalTranslate();
    const displayTitle = /* @__PURE__ */ React45.createElement("div", { className: "flex flex-row items-center" }, /* @__PURE__ */ React45.createElement(
      IconButton3,
      {
        className: "mr-2",
        onClick: () => navigateTo.list(resourceName)
      },
      /* @__PURE__ */ React45.createElement(HiArrowLeft, null)
    ), /* @__PURE__ */ React45.createElement("h1", { className: "text-2xl font-bold" }, t("show.title", { data: { title }, fallback: `${title}` })));
    return /* @__PURE__ */ React45.createElement(
      Content,
      {
        title: !isString5(title) ? title : displayTitle,
        isLoading: queryResult.isLoading,
        extra: /* @__PURE__ */ React45.createElement(React45.Fragment, null, allowEdit && /* @__PURE__ */ React45.createElement(
          Button7,
          {
            disabled: queryResult.isLoading,
            onClick: () => navigateTo.edit(resourceName, resourceId),
            variant: "solid",
            size: "sm",
            className: "min-w-[6rem]"
          },
          translate("buttons.edit", "Edit")
        ), allowDelete && /* @__PURE__ */ React45.createElement(
          AlertDialog.Root,
          {
            open: showDeleteConfirmation,
            onOpenChange: setShowDeleteConfirmation
          },
          /* @__PURE__ */ React45.createElement(AlertDialog.Trigger, { asChild: true }, /* @__PURE__ */ React45.createElement(
            Button7,
            {
              variant: "danger",
              size: "sm",
              className: "min-w-[6rem]",
              disabled: queryResult.isLoading
            },
            translate("buttons.delete", "Delete")
          )),
          /* @__PURE__ */ React45.createElement(AlertDialog.Portal, null, /* @__PURE__ */ React45.createElement(AlertDialog.Overlay, null), /* @__PURE__ */ React45.createElement(AlertDialog.Content, null, /* @__PURE__ */ React45.createElement(AlertDialog.Title, null, translate(
            `${resourceName}.deleteTitle`,
            `Delete ${getResourceLabel(resourceLabel, {
              type: "singular",
              capitalize: true
            })}`
          )), /* @__PURE__ */ React45.createElement(AlertDialog.Description, null, t("messages.deleteResourceConfirmation", {
            fallback: scalingworks_default.messages.deleteResourceConfirmation,
            data: {
              resource: resourceName
            }
          })), /* @__PURE__ */ React45.createElement(AlertDialog.Footer, { className: "justify-end" }, /* @__PURE__ */ React45.createElement(AlertDialog.Cancel, { asChild: true }, /* @__PURE__ */ React45.createElement(Button7, null, translate("buttons.cancel", "Cancel"))), /* @__PURE__ */ React45.createElement(
            Button7,
            {
              variant: "danger",
              onClick: () => deleteOperation.mutate(
                {
                  id: resourceId,
                  resource: resourceName
                },
                {
                  onSuccess: () => navigateTo.list(resourceName)
                }
              ),
              loading: deleteOperation.isLoading
            },
            translate("buttons.delete", "Delete")
          ))))
        ))
      },
      sections ? /* @__PURE__ */ React45.createElement("div", { className: "flex flex-col gap-5" }, sections.map(
        (section, index) => section.type === "card" ? /* @__PURE__ */ React45.createElement(
          ResourceCardSection,
          {
            ...section,
            resourceName,
            resourceId,
            key: index
          }
        ) : section.type === "stats" ? /* @__PURE__ */ React45.createElement(
          ResourceStatsSection,
          {
            ...section,
            resourceName,
            resourceId,
            key: index
          }
        ) : section.type === "tabs" ? /* @__PURE__ */ React45.createElement(
          ResourceTabsSection,
          {
            ...section,
            resourceName,
            resourceId,
            key: index
          }
        ) : section.type === "related" ? /* @__PURE__ */ React45.createElement(
          ResourceRelatedResourceSection,
          {
            ...section,
            resourceName,
            resourceId,
            key: index
          }
        ) : null
      )) : /* @__PURE__ */ React45.createElement(React45.Fragment, null, queryResult.isLoading && /* @__PURE__ */ React45.createElement("p", null, "Loading..."), queryResult.data && /* @__PURE__ */ React45.createElement(
        JsonPrettyViewer,
        {
          json: queryResult.data.data,
          fieldLabel: t("pages.show.field", { fallback: "FIELD" }),
          valueLabel: t("pages.show.value", { fallback: "VALUE" })
        }
      ))
    );
  };
  return DefaultShowPage;
};

// src/components/create-resource-create-page.tsx
import { useNavigation as useNavigation4, useTranslate as useTranslate9 } from "@refinedev/core";
import { useForm as useForm3 } from "@refinedev/react-hook-form";
import { Button as Button8, isFunction as isFunction5 } from "@scalingworks/react-admin-ui";
import { capitalCase as capitalCase2 } from "change-case";
import * as React46 from "react";
import { Helmet as Helmet3 } from "react-helmet";
var createResourceCreatePage = (options) => {
  const defaultValues = isFunction5(options.defaultValues) ? options.defaultValues({}) : options.defaultValues;
  const ResourceCreatePage = () => {
    const getResourceLabel = useGetResourceLabel(options.resourceName);
    const resourceName = getResourceLabel(options.resourceLabel, { type: "singular" });
    const t = useTranslate9();
    const pageTitle = t(
      `${options.resourceName}.createTitle`,
      `Create ${capitalCase2(resourceName)}`
    );
    const translate = useTranslate9();
    const form = useForm3({
      refineCoreProps: {
        resource: options.resourceName,
        action: "create",
        redirect: "show",
        errorNotification: false
      }
    });
    const navigateTo = useNavigation4();
    const formId = `create-${options.resourceName}-form`;
    const concreteControlsOverride = React46.useMemo(() => {
      if (options.controls) {
        const { components, ...restControlConfig } = options.controls;
        return {
          ...restControlConfig,
          components: isFunction5(components) ? components({ action: "create", t }) : components
        };
      }
      return void 0;
    }, []);
    return /* @__PURE__ */ React46.createElement(React46.Fragment, null, /* @__PURE__ */ React46.createElement(Helmet3, null, /* @__PURE__ */ React46.createElement("title", null, pageTitle)), /* @__PURE__ */ React46.createElement(
      Content,
      {
        title: pageTitle,
        extra: /* @__PURE__ */ React46.createElement(React46.Fragment, null, /* @__PURE__ */ React46.createElement(Button8, { onClick: () => navigateTo.list(options.resourceName), size: "sm" }, translate("buttons.cancel", "Cancel")), /* @__PURE__ */ React46.createElement(
          Button8,
          {
            form: formId,
            type: "submit",
            disabled: form.refineCore.formLoading,
            loading: form.refineCore.mutationResult.isLoading,
            size: "sm",
            variant: "solid"
          },
          translate("buttons.create", "Create")
        ))
      },
      /* @__PURE__ */ React46.createElement(
        DynamicForm,
        {
          form,
          defaultValues,
          controls: concreteControlsOverride,
          formatBeforeSubmit: options.formatBeforeSubmit,
          submitText: translate("buttons.create", "Create"),
          id: formId,
          inferSections: true
        }
      )
    ));
  };
  return ResourceCreatePage;
};

// src/components/create-resource-edit-page.tsx
import { useNavigation as useNavigation5, useRouterContext as useRouterContext3, useTranslate as useTranslate10 } from "@refinedev/core";
import { useForm as useForm4 } from "@refinedev/react-hook-form";
import { Button as Button9, isFunction as isFunction6 } from "@scalingworks/react-admin-ui";
import * as React47 from "react";
import { Helmet as Helmet4 } from "react-helmet";
var createResourceEditPage = (options) => {
  const defaultValues = isFunction6(options.defaultValues) ? options.defaultValues({}) : options.defaultValues;
  const ResourceEditPage = () => {
    const getResourceLabel = useGetResourceLabel(options.resourceName);
    const translate = useTranslate10();
    const pageTitle = translate(
      `${options.resourceName}.editTitle`,
      `Edit ${getResourceLabel(options.resourceLabel, { type: "singular", capitalize: true })}`
    );
    const { useParams } = useRouterContext3();
    const params = useParams();
    const form = useForm4({
      refineCoreProps: {
        resource: options.resourceName,
        id: params.id,
        action: "edit",
        metaData: {
          fields: options.fields
        },
        errorNotification: false
      }
    });
    const navigateTo = useNavigation5();
    const formId = `edit-${options.resourceName}-form`;
    const t = useInternalTranslate();
    const concreteControlsOverride = React47.useMemo(() => {
      if (options.controls) {
        const { components, ...restControlConfig } = options.controls;
        return {
          ...restControlConfig,
          components: isFunction6(components) ? components({ action: "edit", t }) : components
        };
      }
      return void 0;
    }, []);
    return /* @__PURE__ */ React47.createElement(React47.Fragment, null, /* @__PURE__ */ React47.createElement(Helmet4, null, /* @__PURE__ */ React47.createElement("title", null, pageTitle)), /* @__PURE__ */ React47.createElement(
      Content,
      {
        title: pageTitle,
        extra: /* @__PURE__ */ React47.createElement(React47.Fragment, null, /* @__PURE__ */ React47.createElement(Button9, { onClick: () => navigateTo.goBack(), size: "sm" }, translate("buttons.cancel", "Cancel")), /* @__PURE__ */ React47.createElement(
          Button9,
          {
            form: formId,
            type: "submit",
            disabled: form.refineCore.formLoading,
            loading: form.refineCore.mutationResult.isLoading,
            size: "sm",
            variant: "solid"
          },
          translate("buttons.save", "Save")
        ))
      },
      /* @__PURE__ */ React47.createElement(
        DynamicForm,
        {
          form,
          defaultValues,
          controls: concreteControlsOverride,
          formatBeforeSubmit: options.formatBeforeSubmit,
          submitText: translate("buttons.save", "Save"),
          id: formId,
          inferSections: true
        }
      )
    ));
  };
  return ResourceEditPage;
};

// src/components/create-resource-listing-page.tsx
import { useNavigation as useNavigation6, useNotification as useNotification2, useTranslate as useTranslate11 } from "@refinedev/core";
import { useConstant as useConstant2, useForceUpdate, usePrevious as usePrevious2 } from "@reach/utils";
import {
  Button as Button10,
  isFunction as isFunction7,
  isObject as isObject5,
  isString as isString6,
  usePersistedState as usePersistedState2
} from "@scalingworks/react-admin-ui";
import { clsx as clsx9 } from "clsx";
import * as React49 from "react";
import { Helmet as Helmet5 } from "react-helmet";
import { HiPlusCircle } from "react-icons/hi";

// src/lib/system-notification.ts
var isSupported = () => "Notification" in window;
var isPermissionGranted = () => isSupported() && Notification.permission === "granted";
var requestNotificationPermission = () => isSupported() ? isPermissionGranted() ? Promise.resolve(Notification.permission) : Notification.requestPermission() : Promise.reject(new Error(`Notification unsupported`));
var addNotification = (text) => {
  if (!isSupported()) {
    return Promise.reject(new Error(`Notification unsupported`));
  }
  if (isPermissionGranted()) {
    new Notification(text);
  } else {
    requestNotificationPermission().then((permission) => {
      if (permission === "granted") {
        new Notification(text);
      }
    });
  }
};

// src/components/resource-listing-tabs.tsx
import { MultiSelect, Select, Switch, Tabs as Tabs2, TextTooltip as TextTooltip2 } from "@scalingworks/react-admin-ui";
import { clsx as clsx8 } from "clsx";
import * as React48 from "react";
import { MdOutlineChecklist } from "react-icons/md";
var ResourceListingTabs = ({
  config,
  setFilters
}) => {
  const [activeIndexes, setActiveIndexes] = React48.useState([0]);
  const [isMultiSelect, setIsMultiSelect] = React48.useState(false);
  const id = React48.useId();
  const t = useInternalTranslate();
  React48.useEffect(() => {
    const filters = activeIndexes.map((index) => config.options[index].filterValue);
    const filterValues = Array.isArray(filters) ? filters : [filters];
    setFilters(formatFilters(filterValues));
  }, [activeIndexes]);
  const selectTab = React48.useCallback(
    (index) => {
      if (isMultiSelect) {
        setActiveIndexes(
          (prevIndexes) => prevIndexes.includes(index) ? prevIndexes.filter((i) => i !== index) : prevIndexes.concat(index)
        );
      } else {
        setActiveIndexes([index]);
      }
    },
    [isMultiSelect]
  );
  const toggleLabel = t("pages.list.multipleToggle", {
    fallback: scalingworks_default.pages.list.multipleToggle
  });
  const selectOptions = React48.useMemo(
    () => config.options.map((option, index) => ({
      label: option.label({ t }),
      value: index
    })),
    [config.options]
  );
  return /* @__PURE__ */ React48.createElement(
    Tabs2.PlainList,
    {
      className: clsx8(
        "@container/listTab",
        config.allowMultiSelect && "flex justify-between gap-3"
      )
    },
    /* @__PURE__ */ React48.createElement("div", { className: "@xl/listTab:hidden p-1" }, isMultiSelect ? /* @__PURE__ */ React48.createElement(
      MultiSelect,
      {
        value: activeIndexes,
        onValue: (value) => value.length > 0 && setActiveIndexes(value),
        options: selectOptions,
        size: "sm",
        className: "w-52"
      }
    ) : /* @__PURE__ */ React48.createElement(
      Select,
      {
        value: activeIndexes[0],
        onValue: (value) => setActiveIndexes([value]),
        options: selectOptions,
        size: "sm",
        className: "w-52"
      }
    )),
    /* @__PURE__ */ React48.createElement("div", { className: "hidden @xl/listTab:flex items-center" }, config.options.map((tab, index) => {
      const active = activeIndexes.includes(index);
      const disabled = active && isMultiSelect && activeIndexes.length === 1;
      return /* @__PURE__ */ React48.createElement(
        Tabs2.PlainButton,
        {
          onClick: disabled ? void 0 : () => selectTab(index),
          active,
          className: clsx8("border-none", disabled && "cursor-not-allowed"),
          key: index
        },
        tab.label({ t })
      );
    })),
    config.allowMultiSelect && /* @__PURE__ */ React48.createElement("div", { className: "flex items-center gap-2 p-1" }, /* @__PURE__ */ React48.createElement(TextTooltip2, { text: toggleLabel }, /* @__PURE__ */ React48.createElement("label", { htmlFor: id }, /* @__PURE__ */ React48.createElement("span", { className: "sr-only" }, toggleLabel), /* @__PURE__ */ React48.createElement(MdOutlineChecklist, { width: 24, height: 24, className: "w-6 h-6 text-gray-500" }))), /* @__PURE__ */ React48.createElement(
      Switch,
      {
        checked: isMultiSelect,
        onCheckedChange: (checked) => {
          setIsMultiSelect(checked);
          if (!checked && activeIndexes.length > 1) {
            const minIndex = Math.min(...activeIndexes);
            setActiveIndexes([minIndex]);
          }
        },
        id
      }
    ))
  );
};
var formatFilters = (filters) => [
  {
    key: "listingTab",
    operator: "or",
    value: filters
  }
];
var getInitialFilter = (config) => {
  if (config && config.options.length > 0) {
    const filter = config.options[0].filterValue;
    const filterValues = Array.isArray(filter) ? filter : [filter];
    return formatFilters(filterValues);
  }
  return void 0;
};

// src/components/create-resource-listing-page.tsx
var createResourceListingPage = (options) => {
  const timeSensitive = function getTimeSensitiveSettings(timeSensitive2) {
    if (!timeSensitive2) {
      return void 0;
    }
    const { systemNotification = true } = timeSensitive2;
    return {
      ...timeSensitive2,
      systemNotification
    };
  }(
    options.timeSensitive ? isObject5(options.timeSensitive) ? options.timeSensitive : { pollingInterval: 1e4, systemNotification: true } : void 0
  );
  const tabConfig = options.tabs;
  const initialFilter = getInitialFilter(tabConfig);
  const ResourceListingPage = () => {
    const navigateTo = useNavigation6();
    const translate = useTranslate11();
    const t = useInternalTranslate();
    const [rowSelection, setRowSelection] = React49.useState({});
    const filterControls = isFunction7(options.filterControls) ? options.filterControls({
      t
    }) : options.filterControls;
    const {
      table,
      idToBeDelete,
      tableHasFilter,
      searchInputProps,
      hasFilter,
      filterRootProps,
      filterTriggerProps,
      filterContentProps,
      appliedFilterListProps,
      setFilters
    } = useResourceTable({
      resource: options.resourceName,
      columns: options.columns,
      fields: options.fields,
      defaultPageSize: options.defaultPageSize,
      defaultSorter: options.defaultSorter,
      filterControls,
      allowSearch: options.allowSearch,
      searchConfig: options.searchConfig,
      filterConfig: options.filterConfig,
      extraMeta: options.extraMeta,
      ...options?.bulkConfig?.allowBulkSelection ? {
        state: { rowSelection },
        onRowSelectionChange: (r) => setRowSelection(r)
      } : {},
      refineCoreProps: timeSensitive ? {
        queryOptions: {
          refetchInterval: (data) => {
            if (data) {
              const { metadata } = data;
              return metadata.currentPage === 1 ? timeSensitive.pollingInterval : false;
            }
            return timeSensitive.pollingInterval;
          },
          refetchIntervalInBackground: true
        },
        initialFilter
      } : initialFilter && {
        initialFilter
      }
    });
    const [subscribeToChange, setSubscribeToChange] = usePersistedState2(
      false,
      `react-refine.${options.resourceName}.subscribeChange`
    );
    const records = table.refineCore.tableQueryResult.data?.data;
    const newIds = useConstant2(() => /* @__PURE__ */ new Set());
    const previousRecords = usePrevious2(records);
    const forceUpdate = useForceUpdate();
    const notificationHelpers = useNotification2();
    const getResourceLabel = useGetResourceLabel(options.resourceName);
    React49.useEffect(() => {
      if (!subscribeToChange || !timeSensitive || timeSensitive.subscribe) {
        newIds.clear();
        return;
      }
      if (records) {
        const newRecords = previousRecords ? records.filter(
          (rec) => "id" in rec ? previousRecords?.every((prevRec) => !("id" in prevRec) || prevRec.id !== rec.id) : false
        ) : [];
        newRecords.forEach((record) => {
          if ("id" in record && isString6(record.id)) {
            newIds.add(record.id);
          }
        });
        forceUpdate();
        if (newRecords.length > 0) {
          const message = `${getResourceLabel(options.title, {
            type: "plural"
          })}: ${newRecords.length} ${newRecords.length === 1 ? "record" : "records"} added`;
          if (notificationHelpers.open) {
            notificationHelpers.open({
              key: `${(/* @__PURE__ */ new Date()).getTime()}`,
              type: "success",
              message
            });
          }
          if (timeSensitive) {
            if (timeSensitive.systemNotification) {
              addNotification(message);
            }
            if (timeSensitive.onNewNotification) {
              timeSensitive.onNewNotification();
            }
          }
        }
      }
    }, [records]);
    React49.useEffect(() => {
      if (timeSensitive && timeSensitive.subscribe) {
        return timeSensitive.subscribe(function onChangeDetected(message) {
          if (notificationHelpers.open) {
            notificationHelpers.open({
              key: `${(/* @__PURE__ */ new Date()).getTime()}`,
              type: "success",
              message
            });
          }
          if (timeSensitive.systemNotification) {
            addNotification(message);
          }
          if (timeSensitive.onNewNotification) {
            timeSensitive.onNewNotification();
          }
        });
      }
    }, []);
    const { showTitle = true } = options;
    const content = /* @__PURE__ */ React49.createElement(
      Content,
      {
        showTitle,
        title: /* @__PURE__ */ React49.createElement("div", { className: "inline-flex items-center gap-2" }, options.title && /* @__PURE__ */ React49.createElement("h1", { className: "text-2xl" }, getResourceLabel(options.title, { type: "plural" })), /* @__PURE__ */ React49.createElement(
          DataQueryIndicator,
          {
            queryResult: table.refineCore.tableQueryResult,
            timeSensitive: !!timeSensitive,
            onIsWatchingChange: timeSensitive ? (shouldWatch) => {
              if (timeSensitive.onToggleNotification) {
                timeSensitive.onToggleNotification(shouldWatch);
              }
              if (!shouldWatch) {
                setSubscribeToChange(false);
                return;
              }
              if (timeSensitive.systemNotification && isSupported() && !isPermissionGranted()) {
                notificationHelpers.open && notificationHelpers.open({
                  type: "progress",
                  message: "Please grant the permission to send you notification"
                });
                requestNotificationPermission().then((permission) => {
                  if (permission === "granted") {
                    setSubscribeToChange(shouldWatch);
                  }
                });
              } else {
                setSubscribeToChange(shouldWatch);
              }
            } : void 0,
            isWatching: timeSensitive ? subscribeToChange : void 0
          }
        )),
        extra: /* @__PURE__ */ React49.createElement(
          "div",
          {
            className: clsx9(
              options.allowSearch && options.allowCreate && hasFilter ? "flex flex-col w-full @lg/content:w-auto @lg/content:flex-row @lg/content:items-center gap-2" : "flex flex-row gap-2"
            )
          },
          !options?.filterConfig?.alwaysExpanded && options.allowSearch && /* @__PURE__ */ React49.createElement(
            SearchInput,
            {
              fullWidthWhenContentNarrow: options.allowSearch && options.allowCreate && hasFilter,
              ...searchInputProps
            }
          ),
          /* @__PURE__ */ React49.createElement("div", { className: "flex items-center justify-end gap-2" }, !options?.filterConfig?.alwaysExpanded && /* @__PURE__ */ React49.createElement(FilterControlsCollapsible.Trigger, { ...filterTriggerProps }), options.allowCreate && /* @__PURE__ */ React49.createElement(React49.Fragment, null, options.createConfig?.render ? /* @__PURE__ */ React49.createElement("div", { className: "min-w-[7rem]" }, options.createConfig?.render()) : /* @__PURE__ */ React49.createElement(
            Button10,
            {
              onClick: () => navigateTo.create(options.resourceName),
              variant: "solid",
              size: "sm",
              className: "min-w-[7rem]",
              icon: /* @__PURE__ */ React49.createElement(HiPlusCircle, null)
            },
            isFunction7(options.createConfig?.title) ? options?.createConfig?.title({ t: translate }) : translate("buttons.create", "Create")
          )))
        )
      },
      options.headerContent?.({ t }),
      tabConfig && (tabConfig?.options?.length || 0) > 1 && /* @__PURE__ */ React49.createElement(ResourceListingTabs, { config: tabConfig, setFilters }),
      /* @__PURE__ */ React49.createElement("section", { className: "p-4" }, options.allowSearch && /* @__PURE__ */ React49.createElement(
        SearchInput,
        {
          ...searchInputProps,
          fullWidthWhenContentNarrow: false,
          containerType: "fixed"
        }
      ), /* @__PURE__ */ React49.createElement("div", { className: "py-4" }, hasFilter && /* @__PURE__ */ React49.createElement(FilterControlsCollapsible.Content, { ...filterContentProps, className: "mb-3" }))),
      /* @__PURE__ */ React49.createElement(AppliedFilterList, { ...appliedFilterListProps, className: "mb-3" }),
      /* @__PURE__ */ React49.createElement(
        DataTable,
        {
          tableConfig: table,
          bulkConfig: options?.bulkConfig,
          idToBeDelete,
          hasFilter: tableHasFilter,
          highlightedIds: newIds
        }
      )
    );
    return /* @__PURE__ */ React49.createElement(React49.Fragment, null, /* @__PURE__ */ React49.createElement(Helmet5, null, /* @__PURE__ */ React49.createElement("title", null, options.customHelmet || options.title)), hasFilter ? /* @__PURE__ */ React49.createElement(FilterControlsCollapsible.Root, { ...filterRootProps }, content) : content);
  };
  return ResourceListingPage;
};

// src/components/create-resource-show-page.tsx
import { useRouterContext as useRouterContext4 } from "@refinedev/core";
import { isFunction as isFunction8, isString as isString7 } from "@scalingworks/react-admin-ui";
import * as React50 from "react";
import { Helmet as Helmet6 } from "react-helmet";

// src/hooks/use-resource-show.ts
import { useShow as useShow4 } from "@refinedev/core";
var useResourceShow = ({
  fields,
  metaData = {},
  ...props
}) => useShow4({
  ...props,
  metaData: {
    ...metaData,
    fields
  }
});

// src/components/create-resource-show-page.tsx
var createResourceShowPage = ({
  resourceName,
  label,
  config,
  allowDelete,
  allowEdit
}, helpers) => {
  const { fields } = config;
  helpers.addFieldsForCaching(resourceName, fields);
  if (config._fieldDependencies) {
    config._fieldDependencies.forEach(function cacheFields(deps) {
      if (deps.children) {
        deps.children.forEach((child) => cacheFields(child));
      } else {
        helpers.addFieldsForCaching(resourceName, deps.fields);
      }
    });
  }
  const ResourceDetailsPage = () => {
    const getResourceLabel = useGetResourceLabel(resourceName);
    const ensuredResourceLabel = getResourceLabel(label, { type: "singular", capitalize: true });
    const defaultTitle = isString7(config.title) ? config.title : ensuredResourceLabel;
    const getTitle = (resourceData) => {
      if (isFunction8(config.title)) {
        if (resourceData) {
          return config.title(resourceData);
        } else {
          return null;
        }
      }
      return defaultTitle;
    };
    const { useParams } = useRouterContext4();
    const params = useParams();
    const { queryResult } = useResourceShow({
      resource: resourceName,
      id: params.id,
      fields
    });
    const pageTitle = getTitle(queryResult.data?.data);
    return /* @__PURE__ */ React50.createElement(React50.Fragment, null, /* @__PURE__ */ React50.createElement(Helmet6, null, /* @__PURE__ */ React50.createElement("title", null, isString7(pageTitle) ? pageTitle : defaultTitle)), /* @__PURE__ */ React50.createElement(
      config.component,
      {
        queryResult,
        title: pageTitle,
        resourceId: params.id,
        allowDelete,
        allowEdit,
        resourceLabel: ensuredResourceLabel
      }
    ));
  };
  return ResourceDetailsPage;
};

// src/create-resource.tsx
var createResource = (options) => (helpers) => {
  const {
    allowCreate = true,
    allowEdit = true,
    allowDelete = false,
    controls,
    show: {
      component: showComponent,
      fields: showFields = options.fields,
      title: showTitle,
      _fieldDependencies
    } = {
      component: createDefaultShowPage({
        resourceName: options.name
      })
    }
  } = options;
  const ListingPage = options.list && "render" in options.list ? createCustomPage(options.list) : createResourceListingPage({
    resourceName: options.name,
    title: options.label,
    columns: options.columns,
    fields: options.fields,
    defaultPageSize: options.defaultPageSize,
    defaultSorter: options.defaultSorter,
    allowCreate,
    createConfig: options.createConfig,
    allowSearch: options.allowSearch,
    searchConfig: options.searchConfig,
    filterConfig: options.filterConfig,
    bulkConfig: options.bulkConfig,
    filterControls: options.filterControls,
    timeSensitive: options.timeSensitive,
    tabs: options.list?.tabs,
    headerContent: options.headerContent
  });
  const CreatePage = allowCreate ? options.create && "render" in options.create ? createCustomPage(options.create) : createResourceCreatePage({
    resourceName: options.name,
    resourceLabel: options.label,
    defaultValues: options.defaultValues,
    controls,
    formatBeforeSubmit: options.formatBeforeSubmit
  }) : void 0;
  const EditPage = allowEdit ? options.edit && "render" in options.edit ? createCustomPage(options.edit) : createResourceEditPage({
    resourceName: options.name,
    resourceLabel: options.label,
    defaultValues: options.defaultValues,
    controls,
    formatBeforeSubmit: options.formatBeforeSubmit,
    fields: options.fields
  }) : void 0;
  const ShowPage = createResourceShowPage(
    {
      label: options.label,
      resourceName: options.name,
      config: {
        component: showComponent,
        fields: showFields,
        title: showTitle,
        _fieldDependencies
      },
      allowDelete,
      allowEdit
    },
    helpers
  );
  return {
    name: options.name,
    icon: options.icon,
    list: ListingPage,
    create: CreatePage,
    edit: EditPage,
    show: ShowPage,
    options: {
      route: options.name,
      label: options.label
    },
    dataProvider: options.dataProvider
  };
};
var groupResources = (options) => [
  () => ({
    name: options.groupName,
    icon: options.icon,
    options: {
      label: options.label
    }
  }),
  ...options.resources.map(
    (getResource) => (helpers) => ({
      ...getResource(helpers),
      parentName: options.groupName
    })
  )
];

// src/helper-fn.tsx
import * as React51 from "react";
var defineCustomPage = (pageConfig) => pageConfig;
function createHelpers(options) {
  function defineControl(component) {
    return component;
  }
  function defineControlComponents(components) {
    return components;
  }
  return {
    defineDefaults(defaults) {
      return defaults;
    },
    defineFields(fields) {
      return fields;
    },
    defineControl,
    defineControlComponents,
    defineFilterControls(filters) {
      return filters;
    },
    defineResourceCheckbox(config) {
      return {
        type: "resource-checkbox",
        config
      };
    },
    defineResourceSelect(config) {
      return {
        type: "resource-select",
        config
      };
    },
    defineCardSection(section) {
      return {
        ...section,
        type: "card"
      };
    },
    defineRelatedResourceSection(section) {
      return {
        ...section,
        type: "related"
      };
    },
    defineStatsSection(section) {
      return {
        ...section,
        type: "stats"
      };
    },
    defineTabsSection(section) {
      return {
        ...section,
        type: "tabs"
      };
    },
    defineCustomPage,
    defineShowPage({
      sections,
      component = createDefaultShowPage({
        resourceName: options.resourceName,
        sections
      }),
      ...pageConfig
    }) {
      const _fieldDependencies = function collectDependencies(providedSections) {
        if (!providedSections) {
          return void 0;
        }
        const dependencies = [];
        providedSections.forEach(function collectDependencies2(section) {
          if (section.type === "card" || section.type === "stats") {
            dependencies.push({
              fields: section.fields
            });
          } else if (section.type === "tabs") {
            section.tabs[0]?.content.forEach(
              (tabSection) => collectDependencies2(tabSection)
            );
          }
        });
        return dependencies;
      }(sections);
      return {
        ...pageConfig,
        component,
        _fieldDependencies
      };
    },
    useShow(props) {
      return useResourceShow({
        ...props,
        resource: options.resourceName
      });
    },
    useSelect(props) {
      return useResourceSelect({
        ...props,
        resource: options.resourceName
      });
    },
    useTable(props) {
      return useResourceTable({
        ...props,
        resource: options.resourceName
      });
    },
    createTableComponent(props) {
      const config = {
        ...props,
        resource: options.resourceName
      };
      return function ResourceTableComponent() {
        return /* @__PURE__ */ React51.createElement(ResourceTable, { config });
      };
    }
  };
}
export {
  Content,
  DynamicForm,
  Form2 as Form,
  LinkToDetails,
  SearchInput,
  createHelpers,
  createRefineAdminApp,
  createResource,
  createResourceListingPage,
  defineCustomPage,
  groupResources,
  sentenceCase2 as sentenceCase,
  useFileUploads,
  useGraphQLClient,
  useMakePresignedUrl,
  usePrefetch,
  useResourceSelect,
  useResourceShow,
  useResourceTable
};
//# sourceMappingURL=index.mjs.map